var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNothingSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-data-analysis",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes heartbeat{0%,30%,40%,60%,to{transform:scale(1)}10%,50%{transform:scale(1.1)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}svg#freepik_stories-data-analysis:not(.animated) .animable{opacity:0}svg#freepik_stories-data-analysis.animated #freepik--speech-bubble--inject-138{animation:1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown;animation-delay:0s}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-138",
    className: "animable",
    style: {
      transformOrigin: "250px 343.995px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-138",
    d: "M86.26 249.46c-90.43 52.21-90.43 136.86 0 189.07s237.05 52.21 327.48 0 90.43-136.86 0-189.07-237.05-52.21-327.48 0Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "250px 343.995px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-138",
    className: "animable",
    style: {
      transformOrigin: "258.905px 410.001px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-138",
    d: "M104.53 409.13c14.2 8.3 14.2 21.74 0 30s-37.23 8.3-51.43 0-14.21-21.73 0-30 37.22-8.29 51.43 0Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "78.8131px 424.13px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-138",
    d: "M455.68 371.34c26.25 15.32 26.24 40.16 0 55.49s-68.8 15.32-95.05 0-26.24-40.17 0-55.49 68.8-15.34 95.05 0Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "408.155px 399.083px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.14 373.66a10.17 10.17 0 0 1 5 1.23l3.75 2.17a4.22 4.22 0 0 1 0 7.82s-63.81 31.83-63.81 31.84c4.42 4.9 6.38 10.42 5.69 16.07-.88 7.2-6.15 13.93-14.84 18.95-9.41 5.43-21.88 8.42-35.13 8.42s-25.73-3-35.13-8.42c-9.66-5.58-15-13.08-15-21.12s5.32-15.54 15-21.12c9.4-5.43 21.88-8.42 35.12-8.42 12.76 0 24.83 2.78 34.1 7.85l59.65-33.73a10.23 10.23 0 0 1 5.6-1.54Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "256.096px 416.909px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab-3--inject-138",
    className: "animable",
    style: {
      transformOrigin: "221.135px 217.893px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-138",
    className: "animable",
    style: {
      transformOrigin: "221.135px 217.893px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-138",
    className: "animable",
    style: {
      transformOrigin: "221.135px 217.893px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.1 28.68a2.09 2.09 0 0 0-.09-.51.11.11 0 0 0 0-.11 1.83 1.83 0 0 0-.13-.5 2.41 2.41 0 0 0-.33-.71.88.88 0 0 0-.18-.29.64.64 0 0 0-.16-.2 1.62 1.62 0 0 0-.37-.37 2.2 2.2 0 0 0-.47-.27 4 4 0 0 0-3.75.47l-165.77 95.42c-3.07 1.77-5.58 6.11-5.58 12.32v276.55a3.78 3.78 0 0 0 2 3.35l.24.16c.09.05.18.11.29.16a2.48 2.48 0 0 0 .48.17 3.45 3.45 0 0 0 .71.09 3.62 3.62 0 0 0 1.85-.53l.15-.09 5.32-3.07 160.23-92.39a12.32 12.32 0 0 0 5.58-9.66V29.38c.02-.24 0-.48-.02-.7Z",
    style: {
      fill: "#fff",
      transformOrigin: "224.699px 219.932px"
    },
    id: "elylvgyer57br",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 27a1.38 1.38 0 0 1 .63.14l.1.05.09.07.05.05.14.18.11.18a.65.65 0 0 1 .11.22v.07l.15.45v.14a1 1 0 0 1 0 .15V308.67a10.76 10.76 0 0 1-4.78 8.28l-160.07 92.38-5.17 3h-.05l-.15.1-.1.06a2.22 2.22 0 0 1-1 .32H140a2.38 2.38 0 0 1-.37-.05h-.1l-.15-.08-.12-.08-.09-.06h-.13a2.18 2.18 0 0 1-1.17-1.94V133.93c0-6 2.47-9.6 4.78-10.94l165.7-95.45A3.59 3.59 0 0 1 310 27m0-1.6a5.15 5.15 0 0 0-2.47.75l-165.68 95.46c-3.07 1.77-5.58 6.11-5.58 12.32v276.54a3.78 3.78 0 0 0 2 3.35l.24.16c.09.05.18.11.29.16a2.48 2.48 0 0 0 .48.17 3.45 3.45 0 0 0 .71.09h.08a3.62 3.62 0 0 0 1.77-.53l.15-.09 5.32-3.07 160.23-92.39a12.32 12.32 0 0 0 5.58-9.66V28.68a2.09 2.09 0 0 0-.09-.51.11.11 0 0 0 0-.11 1.83 1.83 0 0 0-.13-.5 2.41 2.41 0 0 0-.33-.71.88.88 0 0 0-.18-.29.64.64 0 0 0-.16-.2 1.62 1.62 0 0 0-.37-.37 2.2 2.2 0 0 0-.47-.27 3 3 0 0 0-1.39-.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "224.695px 219.9px"
    },
    id: "elou7qpn9zgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.31 25.68a4 4 0 0 0-3.75.47l-165.71 95.46a12.36 12.36 0 0 0-5.58 9.66v10.82l-7.12-4.17v-10.69a12.33 12.33 0 0 1 5.56-9.65l165.73-95.45a3.86 3.86 0 0 1 4-.33c1.05.6 5.68 3.26 6.87 3.88Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "220.23px 81.7406px"
    },
    id: "elk9z5smo8me",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.13 29.34c0-3.52-2.51-4.95-5.58-3.18l-165.7 95.45a12.34 12.34 0 0 0-5.58 9.66v10.83L313.13 40.23Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "224.7px 83.7502px"
    },
    id: "el5k0xdzykicf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "221.065px 73.5632px"
    },
    className: "animable",
    id: "eldromq16inwi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m307.55 26.16-165.7 95.45a11.43 11.43 0 0 0-3.92 4.14l-7.09-4.1a11 11 0 0 1 3.88-4.07l165.71-95.46a3.92 3.92 0 0 1 4.05-.33c1 .62 5.63 3.25 6.81 3.88a4.07 4.07 0 0 0-3.74.49Z",
    style: {
      fill: "#fff",
      transformOrigin: "221.065px 73.5632px"
    },
    id: "elnrvhudcv77d",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.14 137.94v-10.72a11.55 11.55 0 0 1 1.7-5.57l7.1 4.08a11.34 11.34 0 0 0-1.66 5.54v10.83Z",
    style: {
      opacity: 0.15,
      transformOrigin: "133.54px 131.875px"
    },
    className: "animable",
    id: "el99vky0p9ly"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.91 42.42a5.66 5.66 0 0 0-2.37 4.52c0 1.75 1.06 2.55 2.37 1.79a5.66 5.66 0 0 0 2.37-4.52c0-1.74-1.06-2.55-2.37-1.79Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "288.91px 45.5757px"
    },
    id: "el9h739roj5c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.43 37.49a5.69 5.69 0 0 0-2.36 4.51c0 1.75 1.06 2.55 2.36 1.79a5.66 5.66 0 0 0 2.37-4.52c0-1.73-1.06-2.53-2.37-1.78Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "297.435px 40.6428px"
    },
    id: "elwpr8550ya9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 32.56a5.69 5.69 0 0 0-2.36 4.53c0 1.74 1.06 2.54 2.36 1.79a5.68 5.68 0 0 0 2.37-4.53c-.05-1.74-1.11-2.54-2.37-1.79Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "306.005px 35.72px"
    },
    id: "el8g8y1pae8w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.27 413.85-.28-.16-5.88-3.4a5.94 5.94 0 0 1-2.92-4.33 7.34 7.34 0 0 1-.05-.81V137.92l7.13 4.18v268.37a3.64 3.64 0 0 0 1.73 3.16 1.58 1.58 0 0 0 .18.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "133.705px 275.885px"
    },
    id: "els576ufc6qh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.27 413.85-.28-.16-5.88-3.4a5.94 5.94 0 0 1-2.92-4.33 7.34 7.34 0 0 1-.05-.81V137.92l7.13 4.18v268.37a3.64 3.64 0 0 0 1.73 3.16 1.58 1.58 0 0 0 .18.13Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "133.705px 275.885px"
    },
    className: "animable",
    id: "el1n3yehc6xzu"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-138",
    className: "animable",
    style: {
      transformOrigin: "300.255px 306.066px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-138",
    className: "animable",
    style: {
      transformOrigin: "300.255px 306.066px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "290.685px 303.938px"
    },
    className: "animable",
    id: "elepejs19ux0r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m249.44 280.5 82.5-47.62c.77-.45 1.39-.08 1.39.81v91.25a3.1 3.1 0 0 1-1.39 2.43L249.44 375c-.78.44-1.4.08-1.4-.81v-91.27a3.08 3.08 0 0 1 1.4-2.42Z",
    id: "el2hps12vxz9n",
    className: "animable",
    style: {
      transformOrigin: "290.685px 303.938px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m330 239.29-76.68 44.25a3.4 3.4 0 0 0-1.54 2.67v88.55a3.34 3.34 0 0 0 1.55 2.65l2.93 1.67a3.48 3.48 0 0 0 3.1 0L336 334.82a3.43 3.43 0 0 0 1.54-2.67V243.6a3.37 3.37 0 0 0-1.55-2.66l-2.99-1.67a3.46 3.46 0 0 0-3 .02Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "294.66px 309.191px"
    },
    id: "elvnfyvj8mcem",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 239.29-76.68 44.25a3.4 3.4 0 0 0-1.54 2.67v88.55a3.34 3.34 0 0 0 1.55 2.65l2.93 1.67a3.48 3.48 0 0 0 3.1 0L336 334.82a3.43 3.43 0 0 0 1.54-2.67V243.6a3.37 3.37 0 0 0-1.55-2.66l-2.99-1.67a3.46 3.46 0 0 0-3 .02Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "294.66px 309.191px"
    },
    className: "animable",
    id: "eljj55werwmt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.51 243.32c-.12-.78-.76-1.06-1.53-.62L259.31 287a3.18 3.18 0 0 0-1.09 1.15l-6-3.47a3.2 3.2 0 0 1 1.06-1.1L330 239.29a3.46 3.46 0 0 1 3.09 0l2.94 1.67a3.43 3.43 0 0 1 1.48 2.36Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "294.865px 263.538px"
    },
    className: "animable",
    id: "elqw5tk05z7pm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.31 379.06a3.55 3.55 0 0 1-3.1 0l-2.93-1.67a3.34 3.34 0 0 1-1.55-2.65v-88.53a3.17 3.17 0 0 1 .49-1.58l6 3.47a3.15 3.15 0 0 0-.46 1.52v88.55c0 .9.64 1.42 1.55.89Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.5,
      transformOrigin: "255.52px 332.023px"
    },
    className: "animable",
    id: "el8k7hq200s5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 242.71 259.31 287a3.42 3.42 0 0 0-1.55 2.67v88.55c0 1 .7 1.38 1.55.89L336 334.82a3.43 3.43 0 0 0 1.54-2.67V243.6c-.01-.99-.7-1.39-1.54-.89Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "297.65px 310.909px"
    },
    id: "elw8x286tptqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 242.71 259.31 287a3.42 3.42 0 0 0-1.55 2.67v88.55c0 1 .7 1.38 1.55.89L336 334.82a3.43 3.43 0 0 0 1.54-2.67V243.6c-.01-.99-.7-1.39-1.54-.89Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "297.65px 310.909px"
    },
    className: "animable",
    id: "elrecweqkyk4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.29 244v88.2a2.21 2.21 0 0 1-.92 1.6L259 377.82v-88.2a2.23 2.23 0 0 1 .92-1.6L336.29 244m.38-1.46a1.32 1.32 0 0 0-.68.22L259.31 287a3.42 3.42 0 0 0-1.55 2.67v88.55c0 .7.35 1.1.86 1.1a1.43 1.43 0 0 0 .69-.21L336 334.82a3.43 3.43 0 0 0 1.54-2.67V243.6c0-.7-.35-1.11-.86-1.11Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "297.65px 310.905px"
    },
    className: "animable",
    id: "elt9qaglek35o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.52 299.7a.55.55 0 0 0-.56.05l-1.15.77-.25.68a1.32 1.32 0 0 0 .31 1.28c.18.2.36.41.53.64a.76.76 0 0 0 1.06.25l2.7-1.77a.46.46 0 0 1 .53-.05Zm-.91-3-3.19-1.83-.21-.08-2-.46a1.1 1.1 0 0 0-1.15.54l-1.9 3.62a1.83 1.83 0 0 1-.77.71l.6 2a.7.7 0 0 0 1 .44 9 9 0 0 1 1.24-.41 1.92 1.92 0 0 0 1.14-.87l1.91-3.63a1.05 1.05 0 0 1 1.14-.52l2 .45a.64.64 0 0 1 .19 0Zm-6.79 9.78a5 5 0 0 1 .37 1.28c.59 3.45-1.59 8.35-4.87 10.93a6.8 6.8 0 0 1-3.45 1.54c1.07 2.31 3.8 2.53 6.64.3 3.29-2.59 5.46-7.48 4.87-10.93-.38-2.22-1.76-3.31-3.56-3.16Zm-2 23.55h-.08Zm-.95-2.64a.69.69 0 0 0-1-.43 9.11 9.11 0 0 1-1.25.41 1.11 1.11 0 0 0-.39.17l.09.28a.56.56 0 0 0 .26.36l3.12 1.8a.68.68 0 0 1-.19-.31ZM334 305.14l-.18-2.89a1.7 1.7 0 0 1 .57-1.29l3-2.38a.49.49 0 0 1 .61-.07l-3.2-1.85a.38.38 0 0 0-.22 0 .59.59 0 0 0-.37.14l-3 2.39a1.69 1.69 0 0 0-.58 1.27l.19 2.9a2.4 2.4 0 0 1-.47 1.39c-.5.6-1 1.21-1.42 1.86a1.53 1.53 0 0 1-1.23.63l-2-.1a1.25 1.25 0 0 0-1.11.69l-1.83 4.11a.76.76 0 0 0 .3 1l2.17 1.25a1 1 0 0 1 0 .55c-.15.66-.26 1.32-.34 2a2.43 2.43 0 0 1-.65 1.33l-2.69 2.48a1.64 1.64 0 0 0-.45 1.32l.5 2.93a.58.58 0 0 0 .25.4l3.2 1.85a.52.52 0 0 1-.25-.4l-.5-2.93a1.58 1.58 0 0 1 .45-1.32l2.68-2.47a2.47 2.47 0 0 0 .66-1.33 17.12 17.12 0 0 1 .34-2 1 1 0 0 0-.55-1.09l-1.57-.67a.78.78 0 0 1-.41-1l1.83-4.11a1.28 1.28 0 0 1 1.12-.69l2 .1a1.62 1.62 0 0 0 1.24-.62c.44-.65.91-1.27 1.4-1.87a2.21 2.21 0 0 0 .51-1.51Zm-4.56 20.21a.78.78 0 0 0-1.08-.24l-1.52 1-1.12 3a.68.68 0 0 0 .26.83l3.17 1.82a.66.66 0 0 1-.24-.8l1.37-3.7A1.32 1.32 0 0 0 330 326a5.69 5.69 0 0 1-.53-.65Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "336.39px 313.036px"
    },
    id: "elflb9s8dbeug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "336.39px 313.036px"
    },
    className: "animable",
    id: "eltyspzrtrmd9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.52 299.7a.55.55 0 0 0-.56.05l-1.15.77-.25.68a1.32 1.32 0 0 0 .31 1.28c.18.2.36.41.53.64a.76.76 0 0 0 1.06.25l2.7-1.77a.46.46 0 0 1 .53-.05Zm-.91-3-3.19-1.83-.21-.08-2-.46a1.1 1.1 0 0 0-1.15.54l-1.9 3.62a1.83 1.83 0 0 1-.77.71l.6 2a.7.7 0 0 0 1 .44 9 9 0 0 1 1.24-.41 1.92 1.92 0 0 0 1.14-.87l1.91-3.63a1.05 1.05 0 0 1 1.14-.52l2 .45a.64.64 0 0 1 .19 0Zm-6.79 9.78a5 5 0 0 1 .37 1.28c.59 3.45-1.59 8.35-4.87 10.93a6.8 6.8 0 0 1-3.45 1.54c1.07 2.31 3.8 2.53 6.64.3 3.29-2.59 5.46-7.48 4.87-10.93-.38-2.22-1.76-3.31-3.56-3.16Zm-2 23.55h-.08Zm-.95-2.64a.69.69 0 0 0-1-.43 9.11 9.11 0 0 1-1.25.41 1.11 1.11 0 0 0-.39.17l.09.28a.56.56 0 0 0 .26.36l3.12 1.8a.68.68 0 0 1-.19-.31ZM334 305.14l-.18-2.89a1.7 1.7 0 0 1 .57-1.29l3-2.38a.49.49 0 0 1 .61-.07l-3.2-1.85a.38.38 0 0 0-.22 0 .59.59 0 0 0-.37.14l-3 2.39a1.69 1.69 0 0 0-.58 1.27l.19 2.9a2.4 2.4 0 0 1-.47 1.39c-.5.6-1 1.21-1.42 1.86a1.53 1.53 0 0 1-1.23.63l-2-.1a1.25 1.25 0 0 0-1.11.69l-1.83 4.11a.76.76 0 0 0 .3 1l2.17 1.25a1 1 0 0 1 0 .55c-.15.66-.26 1.32-.34 2a2.43 2.43 0 0 1-.65 1.33l-2.69 2.48a1.64 1.64 0 0 0-.45 1.32l.5 2.93a.58.58 0 0 0 .25.4l3.2 1.85a.52.52 0 0 1-.25-.4l-.5-2.93a1.58 1.58 0 0 1 .45-1.32l2.68-2.47a2.47 2.47 0 0 0 .66-1.33 17.12 17.12 0 0 1 .34-2 1 1 0 0 0-.55-1.09l-1.57-.67a.78.78 0 0 1-.41-1l1.83-4.11a1.28 1.28 0 0 1 1.12-.69l2 .1a1.62 1.62 0 0 0 1.24-.62c.44-.65.91-1.27 1.4-1.87a2.21 2.21 0 0 0 .51-1.51Zm-4.56 20.21a.78.78 0 0 0-1.08-.24l-1.52 1-1.12 3a.68.68 0 0 0 .26.83l3.17 1.82a.66.66 0 0 1-.24-.8l1.37-3.7A1.32 1.32 0 0 0 330 326a5.69 5.69 0 0 1-.53-.65Z",
    id: "eldhe6w4xsola",
    className: "animable",
    style: {
      transformOrigin: "336.39px 313.036px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m327.72 307.18-2-.1a1.26 1.26 0 0 0-.81.29l3.2 1.85a1.25 1.25 0 0 1 .8-.3l2 .1a1.33 1.33 0 0 0 .57-.12l-3.2-1.84a1.41 1.41 0 0 1-.56.12Zm6.55-10.44-3 2.39a1.56 1.56 0 0 0-.49.78l3.18 1.85a1.64 1.64 0 0 1 .5-.8l3-2.38a.49.49 0 0 1 .61-.07l-3.2-1.85a.54.54 0 0 0-.6.08Zm-12.61 23.7a1.56 1.56 0 0 0-.41.76l3.19 1.85a1.52 1.52 0 0 1 .42-.77l2.65-2.44-3.19-1.84Zm26.86-20.74a.53.53 0 0 0-.56.05l-1.15.77-.25.68a1.14 1.14 0 0 0 0 .85 1.34 1.34 0 0 0 .22.37 1.14 1.14 0 0 1 .15.16c.13.14.26.31.39.48a.76.76 0 0 0 .77.35.14.14 0 0 0 .09 0 .61.61 0 0 0 .2-.09l2.7-1.77a.58.58 0 0 1 .33-.12.41.41 0 0 1 .16 0s0 0 .05 0Zm-.91-3-3.19-1.83-.21-.08-2-.46a1.1 1.1 0 0 0-1.15.54l-1.9 3.62a1.66 1.66 0 0 1-.44.49l3.2 1.84a1.49 1.49 0 0 0 .42-.49l1.91-3.63a1.05 1.05 0 0 1 1.14-.52l2 .45a.64.64 0 0 1 .22.03Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "336.435px 308.681px"
    },
    id: "eloup0g2ed1u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.72 307.18-2-.1a1.26 1.26 0 0 0-.81.29l3.2 1.85a1.25 1.25 0 0 1 .8-.3l2 .1a1.33 1.33 0 0 0 .57-.12l-3.2-1.84a1.41 1.41 0 0 1-.56.12Zm6.55-10.44-3 2.39a1.56 1.56 0 0 0-.49.78l3.18 1.85a1.64 1.64 0 0 1 .5-.8l3-2.38a.49.49 0 0 1 .61-.07l-3.2-1.85a.54.54 0 0 0-.6.08Zm-12.61 23.7a1.56 1.56 0 0 0-.41.76l3.19 1.85a1.52 1.52 0 0 1 .42-.77l2.65-2.44-3.19-1.84Zm26.86-20.74a.53.53 0 0 0-.56.05l-1.15.77-.25.68a1.14 1.14 0 0 0 0 .85 1.34 1.34 0 0 0 .22.37 1.14 1.14 0 0 1 .15.16c.13.14.26.31.39.48a.76.76 0 0 0 .77.35.14.14 0 0 0 .09 0 .61.61 0 0 0 .2-.09l2.7-1.77a.58.58 0 0 1 .33-.12.41.41 0 0 1 .16 0s0 0 .05 0Zm-.91-3-3.19-1.83-.21-.08-2-.46a1.1 1.1 0 0 0-1.15.54l-1.9 3.62a1.66 1.66 0 0 1-.44.49l3.2 1.84a1.49 1.49 0 0 0 .42-.49l1.91-3.63a1.05 1.05 0 0 1 1.14-.52l2 .45a.64.64 0 0 1 .22.03Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "336.435px 308.681px"
    },
    className: "animable",
    id: "el6djxhvmj56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.46 304.87-.51-2.93a.48.48 0 0 0-.8-.34l-2.68 1.76a.77.77 0 0 1-1.08-.24 6.59 6.59 0 0 0-.52-.64 1.33 1.33 0 0 1-.32-1.28l1.37-3.7a.68.68 0 0 0-.5-.92l-2-.46a1.11 1.11 0 0 0-1.15.54l-1.9 3.62a2 2 0 0 1-1.15.87 9.11 9.11 0 0 0-1.25.41.69.69 0 0 1-.95-.44l-.69-2.27a.5.5 0 0 0-.85-.27l-3 2.38a1.72 1.72 0 0 0-.57 1.29l.18 2.88a2.29 2.29 0 0 1-.47 1.4q-.75.9-1.41 1.86a1.57 1.57 0 0 1-1.24.63l-1.94-.1a1.25 1.25 0 0 0-1.12.69l-1.91 4.11a.78.78 0 0 0 .41 1l1.58.67a1 1 0 0 1 .54 1.09 17.12 17.12 0 0 0-.34 2 2.44 2.44 0 0 1-.66 1.33l-2.69 2.47a1.65 1.65 0 0 0-.45 1.32l.51 2.93a.48.48 0 0 0 .8.35l2.68-1.77a.78.78 0 0 1 1.08.25 6.59 6.59 0 0 0 .52.64 1.32 1.32 0 0 1 .32 1.28l-1.37 3.7a.68.68 0 0 0 .5.92l2 .45a1.09 1.09 0 0 0 1.15-.53l1.9-3.63a2.07 2.07 0 0 1 1.15-.86 9.11 9.11 0 0 0 1.25-.41.69.69 0 0 1 1 .44l.68 2.27a.51.51 0 0 0 .86.27l3-2.39a1.68 1.68 0 0 0 .57-1.28l-.18-2.89a2.25 2.25 0 0 1 .48-1.39c.49-.6 1-1.22 1.4-1.87a1.56 1.56 0 0 1 1.24-.62l1.95.09a1.24 1.24 0 0 0 1.12-.69l1.83-4.1a.77.77 0 0 0-.41-1l-1.57-.68a1 1 0 0 1-.54-1.08 17.44 17.44 0 0 0 .33-2 2.47 2.47 0 0 1 .66-1.33l2.7-2.47a1.66 1.66 0 0 0 .46-1.33Zm-12.95 15.62c-3.29 2.58-6.44 1.88-7-1.57s1.59-8.35 4.87-10.93 6.44-1.88 7 1.57-1.59 8.34-4.87 10.93Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "338.425px 314.237px"
    },
    id: "el6p2v4rgvadb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.31 292.86a2.51 2.51 0 0 0 .72-1.45l.7-7.77a1.89 1.89 0 0 1 .84-1.3l7-4a.65.65 0 0 1 .53-.07l-3.4-2a.59.59 0 0 0-.23 0 .66.66 0 0 0-.34.1l-7 4a1.88 1.88 0 0 0-.82 1.3l-.7 7.78a2.57 2.57 0 0 1-.74 1.44A44.43 44.43 0 0 0 283 295a1.31 1.31 0 0 1-1.38.39l-4.47-1.55a1.06 1.06 0 0 0-1.26.47l-5.14 8.88a1.08 1.08 0 0 0 .23 1.32l3.59 3.1a1.35 1.35 0 0 1 .35 1.38 42.8 42.8 0 0 0-1.61 5.42 2.66 2.66 0 0 1-.9 1.35l-6.41 4.47a1.86 1.86 0 0 0-.71 1.37v8.06a.59.59 0 0 0 .24.53l3.44 2a.59.59 0 0 1-.26-.53v-8.06a1.89 1.89 0 0 1 .72-1.37l6.37-4.49a2.56 2.56 0 0 0 .9-1.35 43.84 43.84 0 0 1 1.61-5.41 1.33 1.33 0 0 0-.34-1.39l-3.6-3.1a1.07 1.07 0 0 1-.22-1.31l5.13-8.9a1.1 1.1 0 0 1 1.26-.47l4.48 1.57a1.31 1.31 0 0 0 1.36-.39 42.32 42.32 0 0 1 3.93-4.13Zm-13.51 37a.73.73 0 0 0-1-.47l-1.5.68c.16.31.32.62.49.89a1.73 1.73 0 0 1 .09 1.52l-4.14 8.34a1 1 0 0 0 .37 1.22l3.43 2a1 1 0 0 1-.37-1.21l4.15-8.36a1.72 1.72 0 0 0-.1-1.5 14.11 14.11 0 0 1-1.42-3.14ZM291.72 345l-.67-6.78a.73.73 0 0 0-.93-.65 15.42 15.42 0 0 1-2.34.32l.51 5.13a.6.6 0 0 0 .27.47l3.44 2a.59.59 0 0 1-.28-.49Zm28-55.41a.57.57 0 0 0-.54 0l-4.7 2.12a14.81 14.81 0 0 1 .89 2.18.73.73 0 0 0 1 .48l6.22-2.8a.53.53 0 0 1 .55 0Zm-11.24-14.13-5.16 7.77a1.72 1.72 0 0 1-1.35.67h-1l.16 1.65a.74.74 0 0 0 .94.66 14.77 14.77 0 0 1 3.36-.35 1.66 1.66 0 0 0 1.35-.66l5.16-7.76a.94.94 0 0 1 1.24-.29l-3.44-2a1 1 0 0 0-1.3.27Zm-5.55 21.39a10.74 10.74 0 0 1 1.53 6.25c0 7.52-5.28 16.67-11.79 20.43-2.55 1.47-4.71 2-6.41 1.55 2.11 2.46 5.72 2.81 9.84.43 6.51-3.76 11.8-12.91 11.8-20.43-.04-4.61-2.01-7.54-5.01-8.27Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "294.214px 310.254px"
    },
    id: "el36wz6wva3cw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.31 292.86a2.51 2.51 0 0 0 .72-1.45l.7-7.77a1.89 1.89 0 0 1 .84-1.3l7-4a.65.65 0 0 1 .53-.07l-3.4-2a.59.59 0 0 0-.23 0 .66.66 0 0 0-.34.1l-7 4a1.88 1.88 0 0 0-.82 1.3l-.7 7.78a2.57 2.57 0 0 1-.74 1.44A44.43 44.43 0 0 0 283 295a1.31 1.31 0 0 1-1.38.39l-4.47-1.55a1.06 1.06 0 0 0-1.26.47l-5.14 8.88a1.08 1.08 0 0 0 .23 1.32l3.59 3.1a1.35 1.35 0 0 1 .35 1.38 42.8 42.8 0 0 0-1.61 5.42 2.66 2.66 0 0 1-.9 1.35l-6.41 4.47a1.86 1.86 0 0 0-.71 1.37v8.06a.59.59 0 0 0 .24.53l3.44 2a.59.59 0 0 1-.26-.53v-8.06a1.89 1.89 0 0 1 .72-1.37l6.37-4.49a2.56 2.56 0 0 0 .9-1.35 43.84 43.84 0 0 1 1.61-5.41 1.33 1.33 0 0 0-.34-1.39l-3.6-3.1a1.07 1.07 0 0 1-.22-1.31l5.13-8.9a1.1 1.1 0 0 1 1.26-.47l4.48 1.57a1.31 1.31 0 0 0 1.36-.39 42.32 42.32 0 0 1 3.93-4.13Zm-13.51 37a.73.73 0 0 0-1-.47l-1.5.68c.16.31.32.62.49.89a1.73 1.73 0 0 1 .09 1.52l-4.14 8.34a1 1 0 0 0 .37 1.22l3.43 2a1 1 0 0 1-.37-1.21l4.15-8.36a1.72 1.72 0 0 0-.1-1.5 14.11 14.11 0 0 1-1.42-3.14ZM291.72 345l-.67-6.78a.73.73 0 0 0-.93-.65 15.42 15.42 0 0 1-2.34.32l.51 5.13a.6.6 0 0 0 .27.47l3.44 2a.59.59 0 0 1-.28-.49Zm28-55.41a.57.57 0 0 0-.54 0l-4.7 2.12a14.81 14.81 0 0 1 .89 2.18.73.73 0 0 0 1 .48l6.22-2.8a.53.53 0 0 1 .55 0Zm-11.24-14.13-5.16 7.77a1.72 1.72 0 0 1-1.35.67h-1l.16 1.65a.74.74 0 0 0 .94.66 14.77 14.77 0 0 1 3.36-.35 1.66 1.66 0 0 0 1.35-.66l5.16-7.76a.94.94 0 0 1 1.24-.29l-3.44-2a1 1 0 0 0-1.3.27Zm-5.55 21.39a10.74 10.74 0 0 1 1.53 6.25c0 7.52-5.28 16.67-11.79 20.43-2.55 1.47-4.71 2-6.41 1.55 2.11 2.46 5.72 2.81 9.84.43 6.51-3.76 11.8-12.91 11.8-20.43-.04-4.61-2.01-7.54-5.01-8.27Z",
    style: {
      opacity: 0.2,
      transformOrigin: "294.214px 310.254px"
    },
    className: "animable",
    id: "elupuqfobc0ln"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.36 300.12v-8.06a.52.52 0 0 0-.79-.52l-6.22 2.8a.73.73 0 0 1-1-.47 14.34 14.34 0 0 0-1.39-3.09 1.69 1.69 0 0 1-.09-1.5l4.14-8.35a1 1 0 0 0-.37-1.22l-4.49-2.59a.92.92 0 0 0-1.24.29l-5.16 7.76a1.73 1.73 0 0 1-1.36.67 13.74 13.74 0 0 0-3.36.34.74.74 0 0 1-.93-.66l-.68-6.78a.52.52 0 0 0-.84-.43l-7 4a1.89 1.89 0 0 0-.84 1.3l-.7 7.77a2.57 2.57 0 0 1-.72 1.45 41.05 41.05 0 0 0-3.88 4.11 1.34 1.34 0 0 1-1.37.39l-4.48-1.57a1.09 1.09 0 0 0-1.26.47l-5.13 8.89a1.08 1.08 0 0 0 .22 1.32l3.6 3.1a1.36 1.36 0 0 1 .35 1.38 40.83 40.83 0 0 0-1.62 5.42 2.64 2.64 0 0 1-.89 1.35l-6.38 4.49a1.86 1.86 0 0 0-.71 1.37v8.06a.52.52 0 0 0 .79.52l6.21-2.8a.74.74 0 0 1 1 .48 14.24 14.24 0 0 0 1.38 3.08 1.69 1.69 0 0 1 .1 1.5l-4.14 8.35a.94.94 0 0 0 .36 1.22l4.5 2.6a1 1 0 0 0 1.24-.29l5.16-7.77a1.72 1.72 0 0 1 1.35-.67 13.69 13.69 0 0 0 3.36-.34.74.74 0 0 1 .93.66l.69 6.78a.52.52 0 0 0 .84.43l7-4a1.85 1.85 0 0 0 .83-1.3l.7-7.77a2.52 2.52 0 0 1 .73-1.45 41 41 0 0 0 3.87-4.11 1.37 1.37 0 0 1 1.38-.39l4.48 1.57a1.09 1.09 0 0 0 1.26-.47l5.13-8.89a1.08 1.08 0 0 0-.23-1.32l-3.59-3.1a1.32 1.32 0 0 1-.35-1.38 42.38 42.38 0 0 0 1.62-5.42 2.62 2.62 0 0 1 .89-1.35l6.38-4.49a1.89 1.89 0 0 0 .72-1.37Zm-27.3 25.35c-6.52 3.76-11.8.71-11.8-6.81s5.28-16.67 11.8-20.43 11.79-.71 11.79 6.81-5.28 16.67-11.79 20.43Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "296.065px 311.828px"
    },
    id: "elu0kniwuhtx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.89 294.29-5.14 8.88a1 1 0 0 0-.11.64l3.42 2a1.09 1.09 0 0 1 .13-.64l5.13-8.9a1 1 0 0 1 .87-.51l-3.41-2a1 1 0 0 0-.89.53Zm-3.48 21.45-6.41 4.49a1.89 1.89 0 0 0-.43.49l3.42 2a1.72 1.72 0 0 1 .44-.48l6.37-4.49a2.46 2.46 0 0 0 .51-.51l-3.44-2a2.33 2.33 0 0 1-.46.5Zm23.7-39.41-7 4a2 2 0 0 0-.7.84l3.43 2a1.82 1.82 0 0 1 .71-.85l7-4a.65.65 0 0 1 .53-.07l-3.4-2a.57.57 0 0 0-.57.08Zm12.33-.91-5.16 7.77a1.34 1.34 0 0 1-.34.33l3.44 2a1.33 1.33 0 0 0 .34-.33l5.16-7.76a.94.94 0 0 1 1.24-.29l-3.44-2a1 1 0 0 0-1.24.28Zm14.64 16.1Zm-3.41-2a.6.6 0 0 0-.54 0l-4.7 2.12a12.17 12.17 0 0 1 .51 1.17 8.69 8.69 0 0 1 .37 1 .8.8 0 0 0 .29.4.7.7 0 0 0 .75.08l6.22-2.8a.77.77 0 0 1 .3-.06h.17l-3.41-2Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "294.325px 298.877px"
    },
    id: "elcv00nagnsab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.89 294.29-5.14 8.88a1 1 0 0 0-.11.64l3.42 2a1.09 1.09 0 0 1 .13-.64l5.13-8.9a1 1 0 0 1 .87-.51l-3.41-2a1 1 0 0 0-.89.53Zm-3.48 21.45-6.41 4.49a1.89 1.89 0 0 0-.43.49l3.42 2a1.72 1.72 0 0 1 .44-.48l6.37-4.49a2.46 2.46 0 0 0 .51-.51l-3.44-2a2.33 2.33 0 0 1-.46.5Zm23.7-39.41-7 4a2 2 0 0 0-.7.84l3.43 2a1.82 1.82 0 0 1 .71-.85l7-4a.65.65 0 0 1 .53-.07l-3.4-2a.57.57 0 0 0-.57.08Zm12.33-.91-5.16 7.77a1.34 1.34 0 0 1-.34.33l3.44 2a1.33 1.33 0 0 0 .34-.33l5.16-7.76a.94.94 0 0 1 1.24-.29l-3.44-2a1 1 0 0 0-1.24.28Zm14.64 16.1Zm-3.41-2a.6.6 0 0 0-.54 0l-4.7 2.12a12.17 12.17 0 0 1 .51 1.17 8.69 8.69 0 0 1 .37 1 .8.8 0 0 0 .29.4.7.7 0 0 0 .75.08l6.22-2.8a.77.77 0 0 1 .3-.06h.17l-3.41-2Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "294.325px 298.877px"
    },
    className: "animable",
    id: "elc81ke627m4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-138",
    className: "animable",
    style: {
      transformOrigin: "311.93px 175.863px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-138",
    className: "animable",
    style: {
      transformOrigin: "311.93px 175.863px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.58 156.78v34.82a2.23 2.23 0 0 1-.92 1.6l-89.29 51.48v-34.82a2.21 2.21 0 0 1 .92-1.6l89.29-51.48m.38-1.46a1.46 1.46 0 0 0-.69.21l-89.59 51.66a3.4 3.4 0 0 0-1.54 2.67V245c0 .69.34 1.1.85 1.1a1.43 1.43 0 0 0 .69-.21l89.59-51.66a3.4 3.4 0 0 0 1.55-2.67v-35.14c0-.7-.35-1.1-.86-1.1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "329.48px 200.71px"
    },
    id: "eln1wofp2mh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "297.145px 170.935px"
    },
    className: "animable",
    id: "el0xzra203qsd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m249.44 160.82 95.41-55c.78-.45 1.4-.09 1.4.81v72a3.06 3.06 0 0 1-1.4 2.42l-95.41 55c-.78.45-1.4.09-1.4-.81v-72a3.06 3.06 0 0 1 1.4-2.42Z",
    id: "eljndb0ogqjy",
    className: "animable",
    style: {
      transformOrigin: "297.145px 170.935px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m342.87 112.2-89.6 51.65a3.41 3.41 0 0 0-1.54 2.67v69.29a3.38 3.38 0 0 0 1.55 2.66l2.93 1.66a3.48 3.48 0 0 0 3.1 0l89.59-51.66a3.41 3.41 0 0 0 1.54-2.67v-69.3a3.34 3.34 0 0 0-1.55-2.65l-2.89-1.67a3.46 3.46 0 0 0-3.13.02Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "301.085px 176.155px"
    },
    id: "elflpi60dxhi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.31 240.12a3.55 3.55 0 0 1-3.1 0l-2.93-1.67a3.34 3.34 0 0 1-1.55-2.65v-69.28a3.17 3.17 0 0 1 .49-1.57l6 3.47a3.15 3.15 0 0 0-.46 1.52v69.28c0 .9.64 1.42 1.55.9Z",
    style: {
      opacity: 0.2,
      transformOrigin: "255.52px 202.713px"
    },
    className: "animable",
    id: "el5ecfea4nt8v"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "301.32px 140.126px"
    },
    className: "animable",
    id: "el8mhfxp3uxkx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.42 116.22c-.12-.77-.75-1-1.52-.61l-89.59 51.66a3.18 3.18 0 0 0-1.09 1.15l-6-3.47a3.2 3.2 0 0 1 1.06-1.1l89.6-51.65a3.43 3.43 0 0 1 3.09 0l2.93 1.67a3.37 3.37 0 0 1 1.52 2.35Z",
    style: {
      fill: "#fff",
      transformOrigin: "301.32px 140.126px"
    },
    id: "ela08380i6wug",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m348.9 115.61-89.59 51.66a3.42 3.42 0 0 0-1.55 2.67v69.29c0 1 .7 1.38 1.55.89l89.59-51.66a3.41 3.41 0 0 0 1.54-2.67V116.5c0-.98-.69-1.38-1.54-.89Z",
    style: {
      fill: "#fff",
      transformOrigin: "304.1px 177.867px"
    },
    id: "eldymrxk27wg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.21 116.86v68.93a2.23 2.23 0 0 1-.92 1.6L259 238.87v-68.93a2.23 2.23 0 0 1 .92-1.6l89.29-51.48m.38-1.46a1.43 1.43 0 0 0-.69.21l-89.59 51.66a3.42 3.42 0 0 0-1.55 2.67v69.29c0 .69.35 1.1.86 1.1a1.43 1.43 0 0 0 .69-.21l89.59-51.66a3.41 3.41 0 0 0 1.54-2.67V116.5c0-.69-.34-1.1-.85-1.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "304.1px 177.865px"
    },
    id: "elcwl702yup3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-138",
    className: "animable",
    style: {
      transformOrigin: "304.112px 180.235px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263 228.89a.21.21 0 0 1-.18-.11.2.2 0 0 1 .08-.28l81.34-47a.21.21 0 0 1 .29.08.2.2 0 0 1-.08.28l-81.34 47a.23.23 0 0 1-.11.03Z",
    style: {
      fill: "#455a64",
      transformOrigin: "303.675px 205.181px"
    },
    id: "el6kdyr309d88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 229.9a.21.21 0 0 1-.21-.21v-1.95a.21.21 0 0 1 .21-.21.21.21 0 0 1 .21.21v1.95a.21.21 0 0 1-.21.21Z",
    style: {
      fill: "#455a64",
      transformOrigin: "263px 228.715px"
    },
    id: "el6kvcpnka48y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.56 222a.21.21 0 0 1-.21-.21v-2a.21.21 0 1 1 .42 0v2a.21.21 0 0 1-.21.21Z",
    style: {
      fill: "#455a64",
      transformOrigin: "276.56px 220.79px"
    },
    id: "elrc5gwx6f4h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.12 214.17a.21.21 0 0 1-.21-.21v-2a.21.21 0 0 1 .21-.21.21.21 0 0 1 .21.21v2a.21.21 0 0 1-.21.21Z",
    style: {
      fill: "#455a64",
      transformOrigin: "290.12px 212.96px"
    },
    id: "elz5o3okvpxli",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.68 206.3a.2.2 0 0 1-.21-.2v-2a.21.21 0 0 1 .21-.21.2.2 0 0 1 .2.21v2a.2.2 0 0 1-.2.2Z",
    style: {
      fill: "#455a64",
      transformOrigin: "303.675px 205.095px"
    },
    id: "elhrzwcuesb7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.23 198.44a.21.21 0 0 1-.21-.21v-2a.22.22 0 0 1 .21-.21.21.21 0 0 1 .21.21v2a.21.21 0 0 1-.21.21Z",
    style: {
      fill: "#455a64",
      transformOrigin: "317.23px 197.23px"
    },
    id: "elomha86bdg3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.79 190.57a.21.21 0 0 1-.21-.21v-2a.21.21 0 0 1 .21-.21.21.21 0 0 1 .21.21v2a.21.21 0 0 1-.21.21Z",
    style: {
      fill: "#455a64",
      transformOrigin: "330.79px 189.36px"
    },
    id: "el5scnjpbzvgg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.35 182.71a.21.21 0 0 1-.21-.21v-2a.21.21 0 0 1 .21-.21.22.22 0 0 1 .21.21v2a.22.22 0 0 1-.21.21Z",
    style: {
      fill: "#455a64",
      transformOrigin: "344.35px 181.5px"
    },
    id: "elhy6pjkzk7hn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 209.11c6.78-3.92 8.48 4.89 13.56 2s1.69-20.55 10.17-25.44 6.78 11.74 15.25 6.84 5.08-36.2 13.56-41.09 6.78 19.81 15.25 14.8 3.39-29.48 13.56-35.35v47l-81.35 47Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.7,
      transformOrigin: "303.675px 177.87px"
    },
    className: "animable",
    id: "eloegroa61vrd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.35 139.69v38.11l-81.35 47v-5.87l6-6c.12.3.43.38.79.17a1.86 1.86 0 0 0 .85-1.47.61.61 0 0 0-.21-.52l5.5-8.74a.56.56 0 0 0 .64 0 1.77 1.77 0 0 0 .67-.78l5.43 1.56a1.59 1.59 0 0 0-.17.69c0 .54.38.76.85.49a1.91 1.91 0 0 0 .84-1.47.87.87 0 0 0-.08-.39l5.26-6.08c.13.25.42.31.76.11a1.86 1.86 0 0 0 .84-1.46.65.65 0 0 0-.17-.49l5.43-7.84a.56.56 0 0 0 .68 0 1.91 1.91 0 0 0 .84-1.47.75.75 0 0 0 0-.22l5.13-4.46c.1.38.43.5.83.28a1.92 1.92 0 0 0 .84-1.47.75.75 0 0 0-.09-.39l5.27-6.08c.13.24.42.3.75.1a1.59 1.59 0 0 0 .6-.63l5.58 3.23a1.74 1.74 0 0 0-.25.83c0 .54.38.76.85.49a1.87 1.87 0 0 0 .85-1.47.78.78 0 0 0 0-.22l5.14-4.45c.09.38.42.5.82.27a1.87 1.87 0 0 0 .85-1.47.54.54 0 0 0-.32-.57l5.72-11.56a.63.63 0 0 0 .53-.09 1.86 1.86 0 0 0 .85-1.46l5.08-2.93c0 .54.38.76.85.49a1.87 1.87 0 0 0 .85-1.47.56.56 0 0 0-.32-.58l5.7-11.52a.63.63 0 0 0 .49-.2Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.7,
      transformOrigin: "303.675px 182.245px"
    },
    className: "animable",
    id: "elx8c9rvdqmz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 219.1a.21.21 0 0 1-.15-.35l6-6.05a.21.21 0 0 1 .29 0 .2.2 0 0 1 0 .29l-6 6a.2.2 0 0 1-.14.11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "265.999px 215.871px"
    },
    id: "elekhpht0pm8k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.42 211.24a.2.2 0 0 1-.11 0 .21.21 0 0 1-.07-.29l5.51-8.74a.2.2 0 0 1 .28-.07.21.21 0 0 1 .07.29l-5.51 8.75a.2.2 0 0 1-.17.06Z",
    style: {
      fill: "#455a64",
      transformOrigin: "273.17px 206.679px"
    },
    id: "elkxnfggdhum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.66 203.25h-.06l-5.42-1.56a.21.21 0 0 1-.14-.26.19.19 0 0 1 .25-.14l5.43 1.56a.21.21 0 0 1 .14.26.21.21 0 0 1-.2.14Z",
    style: {
      fill: "#455a64",
      transformOrigin: "279.95px 202.264px"
    },
    id: "eldl0ipzh6qwi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.09 202.58a.18.18 0 0 1-.13-.06.21.21 0 0 1 0-.29l5.27-6.08a.2.2 0 0 1 .29 0 .21.21 0 0 1 0 .29l-5.27 6.08a.21.21 0 0 1-.16.06Z",
    style: {
      fill: "#455a64",
      transformOrigin: "286.74px 199.334px"
    },
    id: "elcdtdlh5qcc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.8 194.64a.16.16 0 0 1-.12 0 .21.21 0 0 1-.06-.29l5.43-7.83a.22.22 0 0 1 .29 0 .21.21 0 0 1 .05.29l-5.39 7.74a.21.21 0 0 1-.2.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "293.507px 190.559px"
    },
    id: "ell3bv2hfw9go",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.72 185.12a.2.2 0 0 1-.16-.07.2.2 0 0 1 0-.29l5.14-4.45a.21.21 0 0 1 .27.31l-5.14 4.45a.17.17 0 0 1-.11.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "300.255px 182.702px"
    },
    id: "eltrsmp3n7qi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.43 179.09a.19.19 0 0 1-.13-.05.22.22 0 0 1 0-.3l5.27-6.08a.22.22 0 0 1 .3 0 .23.23 0 0 1 0 .3l-5.28 6.04a.2.2 0 0 1-.16.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "307.083px 175.845px"
    },
    id: "elctz33qx5lue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.63 175.7h-.1l-5.53-3.25a.2.2 0 0 1-.08-.28.21.21 0 0 1 .29-.08l5.58 3.22a.21.21 0 0 1 .07.29.2.2 0 0 1-.23.1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "313.892px 173.884px"
    },
    id: "ely50vzuhprq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.05 175.34a.23.23 0 0 1-.15-.07.21.21 0 0 1 0-.3l5.13-4.44a.21.21 0 0 1 .27.31l-5.13 4.45a.24.24 0 0 1-.12.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "320.59px 172.922px"
    },
    id: "elwqu2sdqckv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.54 169.11h-.09a.21.21 0 0 1-.1-.28l5.71-11.54a.21.21 0 0 1 .28-.09.21.21 0 0 1 .1.28L324.73 169a.21.21 0 0 1-.19.11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "327.395px 163.144px"
    },
    id: "el3g61i25ozew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.64 156a.22.22 0 0 1-.18-.1.21.21 0 0 1 .07-.29l5.09-2.93a.2.2 0 0 1 .28.07.21.21 0 0 1-.07.29l-5.09 2.96a.19.19 0 0 1-.1 0Z",
    style: {
      fill: "#455a64",
      transformOrigin: "334.18px 154.328px"
    },
    id: "el75sbrld79ne",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.1 151.5h-.09a.21.21 0 0 1-.1-.28l5.7-11.52a.21.21 0 1 1 .38.18l-5.71 11.52a.19.19 0 0 1-.18.1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "340.95px 145.54px"
    },
    id: "elth02hrkjjr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.4 213.35a.62.62 0 0 1-.32-.09.79.79 0 0 1-.36-.73 2.08 2.08 0 0 1 1-1.65.73.73 0 0 1 1.16.67 2.07 2.07 0 0 1-1 1.65.93.93 0 0 1-.48.15Zm.48-2.1a1.67 1.67 0 0 0-.74 1.28c0 .18.05.32.15.37a.42.42 0 0 0 .39-.06 1.67 1.67 0 0 0 .74-1.29.39.39 0 0 0-.14-.36.41.41 0 0 0-.4.06Z",
    style: {
      fill: "#455a64",
      transformOrigin: "269.801px 212.043px"
    },
    id: "el89r9lz96gkx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18 202.58a.57.57 0 0 1-.32-.08.79.79 0 0 1-.36-.73 2.07 2.07 0 0 1 1-1.65.78.78 0 0 1 .8-.06.79.79 0 0 1 .36.73 2.07 2.07 0 0 1-1 1.65.91.91 0 0 1-.48.14Zm.48-2.1a1.7 1.7 0 0 0-.74 1.29.41.41 0 0 0 .14.37.44.44 0 0 0 .4-.06 1.67 1.67 0 0 0 .74-1.29.41.41 0 0 0-.15-.37.42.42 0 0 0-.39.06Z",
    style: {
      fill: "#455a64",
      transformOrigin: "276.58px 201.279px"
    },
    id: "elwfkgvn6pwmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 204.54a.73.73 0 0 1-.33-.08.8.8 0 0 1-.35-.73 2.08 2.08 0 0 1 1-1.65.8.8 0 0 1 .68-.08.78.78 0 0 1 .35.73 2.06 2.06 0 0 1-.95 1.65 1 1 0 0 1-.4.16Zm.76-2.19a.57.57 0 0 0-.28.09 1.67 1.67 0 0 0-.74 1.29.43.43 0 0 0 .14.37.42.42 0 0 0 .39-.06 1.68 1.68 0 0 0 .75-1.29.42.42 0 0 0-.15-.37.2.2 0 0 0-.15-.03Z",
    style: {
      fill: "#455a64",
      transformOrigin: "283.336px 203.249px"
    },
    id: "el1osvu7tgvrf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.74 196.72a.73.73 0 0 1-.33-.08.83.83 0 0 1-.35-.73 2.08 2.08 0 0 1 .95-1.65.8.8 0 0 1 .81-.06.78.78 0 0 1 .35.73 2.07 2.07 0 0 1-.95 1.65 1 1 0 0 1-.48.14Zm.48-2.1a1.67 1.67 0 0 0-.74 1.29.39.39 0 0 0 .14.36.37.37 0 0 0 .39-.06 1.65 1.65 0 0 0 .75-1.28.32.32 0 0 0-.54-.31Z",
    style: {
      fill: "#455a64",
      transformOrigin: "290.116px 195.419px"
    },
    id: "el0w5h6kyuxnqb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.52 186.93a.63.63 0 0 1-.33-.09.8.8 0 0 1-.35-.72 2.07 2.07 0 0 1 1-1.65.8.8 0 0 1 .81-.06.78.78 0 0 1 .35.73 2.07 2.07 0 0 1-.95 1.64 1 1 0 0 1-.53.15Zm.48-2.1a1.67 1.67 0 0 0-.74 1.29.31.31 0 0 0 .53.3 1.67 1.67 0 0 0 .74-1.28.41.41 0 0 0-.14-.37.42.42 0 0 0-.39.06Z",
    style: {
      fill: "#455a64",
      transformOrigin: "296.921px 185.629px"
    },
    id: "el9xhjlxrwdl8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3 181.06a.63.63 0 0 1-.3-.06.78.78 0 0 1-.35-.73 2.07 2.07 0 0 1 .95-1.64.8.8 0 0 1 .81-.06.78.78 0 0 1 .35.73 2.07 2.07 0 0 1-1 1.64 1 1 0 0 1-.46.12Zm.48-2.1a1.67 1.67 0 0 0-.74 1.28c0 .19 0 .32.14.37s.23 0 .39-.06a1.67 1.67 0 0 0 .74-1.28c0-.19-.05-.32-.14-.37a.42.42 0 0 0-.39.06Z",
    style: {
      fill: "#455a64",
      transformOrigin: "303.705px 179.774px"
    },
    id: "elzjrxfj9zfzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.85 177.15a.62.62 0 0 1-.32-.09.78.78 0 0 1-.35-.73 2.06 2.06 0 0 1 .95-1.65.72.72 0 0 1 1.16.67 2.08 2.08 0 0 1-1 1.65 1 1 0 0 1-.44.15Zm.76-2.19a.63.63 0 0 0-.27.08 1.68 1.68 0 0 0-.75 1.29.32.32 0 0 0 .54.31 1.67 1.67 0 0 0 .74-1.29.43.43 0 0 0-.14-.37Z",
    style: {
      fill: "#455a64",
      transformOrigin: "317.237px 175.837px"
    },
    id: "eljgo50zvo0xa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.63 171.27a.61.61 0 0 1-.32-.08.78.78 0 0 1-.35-.73 2.06 2.06 0 0 1 1-1.65.72.72 0 0 1 1.16.67 2.08 2.08 0 0 1-.95 1.65.94.94 0 0 1-.54.14Zm.49-2.1a1.67 1.67 0 0 0-.75 1.29.43.43 0 0 0 .15.37.42.42 0 0 0 .39-.06 1.67 1.67 0 0 0 .74-1.29.43.43 0 0 0-.14-.37.42.42 0 0 0-.39.06Z",
    style: {
      fill: "#455a64",
      transformOrigin: "324.042px 169.962px"
    },
    id: "elq04rbyhvh7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.19 153.66a.73.73 0 0 1-.33-.08.8.8 0 0 1-.35-.73 2.08 2.08 0 0 1 .95-1.65.8.8 0 0 1 .81-.06.78.78 0 0 1 .35.73 2.06 2.06 0 0 1-.95 1.65 1 1 0 0 1-.48.14Zm.48-2.1a1.67 1.67 0 0 0-.74 1.29.43.43 0 0 0 .14.37.42.42 0 0 0 .39-.06 1.68 1.68 0 0 0 .75-1.29c0-.18 0-.32-.15-.37a.42.42 0 0 0-.39.06Z",
    style: {
      fill: "#455a64",
      transformOrigin: "337.566px 152.359px"
    },
    id: "ellzqeu3remlp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.41 157.58a.62.62 0 0 1-.32-.09.78.78 0 0 1-.35-.73 2.07 2.07 0 0 1 .95-1.65.78.78 0 0 1 .8-.06.79.79 0 0 1 .36.73 2.08 2.08 0 0 1-1 1.65 1 1 0 0 1-.44.15Zm.49-2.11a1.68 1.68 0 0 0-.75 1.29c0 .18.05.32.15.37a.42.42 0 0 0 .39-.06 1.67 1.67 0 0 0 .74-1.29.39.39 0 0 0-.14-.36.38.38 0 0 0-.39.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "330.794px 156.274px"
    },
    id: "elpaueix6puf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 140a.66.66 0 0 1-.32-.08.79.79 0 0 1-.36-.73 2.08 2.08 0 0 1 .95-1.65.8.8 0 0 1 .81-.06.78.78 0 0 1 .35.73 2.06 2.06 0 0 1-.95 1.65 1 1 0 0 1-.48.14Zm.76-2.19a.57.57 0 0 0-.28.09 1.67 1.67 0 0 0-.74 1.29.43.43 0 0 0 .14.37.42.42 0 0 0 .39-.06 1.68 1.68 0 0 0 .75-1.29.42.42 0 0 0-.15-.37.2.2 0 0 0-.14-.02Z",
    style: {
      fill: "#455a64",
      transformOrigin: "344.376px 138.699px"
    },
    id: "el8hz12cdqz25",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.08 173.23a.73.73 0 0 1-.33-.08.79.79 0 0 1-.35-.73 2.08 2.08 0 0 1 1-1.65.72.72 0 0 1 1.16.67 2.1 2.1 0 0 1-.95 1.65 1 1 0 0 1-.53.14Zm.75-2.19a.54.54 0 0 0-.27.09 1.67 1.67 0 0 0-.74 1.29.39.39 0 0 0 .14.36.39.39 0 0 0 .39-.05 1.7 1.7 0 0 0 .74-1.29.41.41 0 0 0-.14-.37.21.21 0 0 0-.12-.07Zm-.38-.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "310.482px 171.922px"
    },
    id: "el4i4sxk6wyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.5 211.89a6.8 6.8 0 0 1-3.8-1.71c-2-1.44-4.08-2.92-7.59-.89l-.21-.36c3.75-2.17 6-.53 8.05.91 1.75 1.26 3.26 2.34 5.51 1s2.72-5.21 3.4-9.81c.89-6 1.9-12.83 6.76-15.63 4.42-2.56 6.2.52 7.92 3.5a11.25 11.25 0 0 0 2.79 3.66c1.25.85 2.7.75 4.55-.32 4.14-2.39 5.43-11.54 6.67-20.39s2.56-18.2 6.88-20.7a3.73 3.73 0 0 1 3.21-.49c2.25.84 3.5 4.5 4.72 8s2.4 7 4.46 7.75a3.27 3.27 0 0 0 2.86-.49c4-2.34 4.9-9.06 5.9-16.17 1.11-7.89 2.26-16.06 7.66-19.18l.21.36c-5.23 3-6.36 11.08-7.45 18.88-1 7.21-2 14-6.1 16.46a3.7 3.7 0 0 1-3.23.53c-2.24-.83-3.5-4.48-4.71-8s-2.4-7-4.47-7.78a3.29 3.29 0 0 0-2.85.46c-4.15 2.4-5.43 11.55-6.67 20.4s-2.56 18.2-6.89 20.7c-2 1.14-3.6 1.23-5 .29a11.42 11.42 0 0 1-2.93-3.79c-1.68-2.93-3.28-5.7-7.34-3.35-4.69 2.7-5.68 9.41-6.56 15.33-.7 4.71-1.3 8.77-3.61 10.11a4.33 4.33 0 0 1-2.14.72Z",
    style: {
      fill: "#455a64",
      transformOrigin: "303.675px 171.23px"
    },
    id: "el6b88s9enhts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 149.62c.73-.42 1.33-.08 1.33.77a2.92 2.92 0 0 1-1.33 2.28c-.73.43-1.32.08-1.32-.76a2.92 2.92 0 0 1 1.32-2.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "316.005px 151.147px"
    },
    id: "elzxcnioidsqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.42 171.16a.21.21 0 0 1-.18-.11.2.2 0 0 1 .08-.28l13.49-7.77 1.67-4.82a.17.17 0 0 1 .09-.11l6.78-3.91a.2.2 0 0 1 .28.07.21.21 0 0 1-.07.29l-6.71 3.87-1.67 4.82a.18.18 0 0 1-.1.11l-13.55 7.83a.23.23 0 0 1-.11.01Z",
    style: {
      fill: "#455a64",
      transformOrigin: "299.437px 162.646px"
    },
    id: "eljljysqz14qp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.8 167.8a2 2 0 0 1 .9-1.5l10.06-5.8c.5-.29.9-.09.9.46a1.93 1.93 0 0 1-.9 1.5l-10.06 5.8c-.49.29-.9.08-.9-.46Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "294.73px 164.379px"
    },
    id: "ell7feaudsif9",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-138",
    className: "animable",
    style: {
      transformOrigin: "323.14px 76.0929px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bar-graph--inject-138",
    className: "animable",
    style: {
      transformOrigin: "323.14px 76.0929px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "321.045px 73.956px"
    },
    className: "animable",
    id: "el1k9j9ezy889"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m297.26 65.37 47.57-27.46c.77-.45 1.4-.08 1.4.81v41.41a3.06 3.06 0 0 1-1.4 2.42L297.26 110c-.78.45-1.4.09-1.4-.8V67.79a3.08 3.08 0 0 1 1.4-2.42Z",
    id: "elxdzh9irbqx9",
    className: "animable",
    style: {
      transformOrigin: "321.045px 73.956px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-138",
    className: "animable",
    style: {
      transformOrigin: "324.985px 79.215px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m342.85 44.32-41.76 24.09a3.4 3.4 0 0 0-1.54 2.67v38.7a3.36 3.36 0 0 0 1.55 2.66l2.9 1.66a3.45 3.45 0 0 0 3.1 0L348.88 90a3.4 3.4 0 0 0 1.54-2.67v-38.7a3.35 3.35 0 0 0-1.55-2.63l-2.93-1.66a3.43 3.43 0 0 0-3.09-.02Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "324.985px 79.215px"
    },
    id: "elwtwj8f8nero",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.13 114.09a3.58 3.58 0 0 1-3.1 0l-2.93-1.67a3.35 3.35 0 0 1-1.55-2.66V71.08a3.17 3.17 0 0 1 .45-1.58l6 3.5a3 3 0 0 0-.46 1.51v38.69c.04.9.68 1.41 1.59.89Z",
    style: {
      opacity: 0.2,
      transformOrigin: "303.34px 91.9715px"
    },
    className: "animable",
    id: "el5asrbluob5s"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "325.2px 58.488px"
    },
    className: "animable",
    id: "elcyuix1vjgdh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.4 48.35c-.12-.78-.75-1.06-1.52-.62l-41.75 24.09A3.13 3.13 0 0 0 306 73l-6-3.48a3.08 3.08 0 0 1 1.06-1.09l41.76-24.09a3.46 3.46 0 0 1 3.09 0l2.96 1.66a3.36 3.36 0 0 1 1.53 2.35Z",
    style: {
      fill: "#fff",
      transformOrigin: "325.2px 58.488px"
    },
    id: "elynr1sat65n",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m348.88 47.74-41.75 24.08a3.4 3.4 0 0 0-1.55 2.67v38.71c0 1 .69 1.38 1.55.89L348.88 90a3.4 3.4 0 0 0 1.54-2.67v-38.7c0-.99-.69-1.39-1.54-.89Z",
    style: {
      fill: "#fff",
      transformOrigin: "328px 80.9137px"
    },
    id: "elumyqxbxcegf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.19 49v38.33a2.23 2.23 0 0 1-.92 1.6l-41.45 23.91V74.49a2.23 2.23 0 0 1 .92-1.6L349.19 49m.38-1.45a1.33 1.33 0 0 0-.69.21l-41.75 24.06a3.4 3.4 0 0 0-1.55 2.67v38.71c0 .7.35 1.1.86 1.1a1.46 1.46 0 0 0 .69-.21L348.88 90a3.4 3.4 0 0 0 1.54-2.67v-38.7c0-.7-.34-1.1-.85-1.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "328px 80.915px"
    },
    id: "el0yvhly0jh07",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "328.28px 80.68px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "337.81px 75.145px"
    },
    id: "elhvqwb3w1f9o",
    className: "animable",
    d: "M339.01 89.25V62.42l-2.4-1.38v26.83l2.4 1.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "337.81px 75.145px"
    },
    className: "animable",
    d: "M339.01 89.25V62.42l-2.4-1.38v26.83l2.4 1.38z",
    id: "elkkjenfqd33"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "342.485px 73.83px"
    },
    id: "eld141njaq4j6",
    className: "animable",
    d: "m339.01 89.25 6.95-4.01V58.41l-6.95 4.01v26.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "341.285px 59.725px"
    },
    id: "elcanw69ocbp8",
    className: "animable",
    d: "m345.96 58.41-2.4-1.38-6.95 4.01 2.4 1.38 6.95-4.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.25,
      transformOrigin: "341.285px 59.725px"
    },
    className: "animable",
    d: "m345.96 58.41-2.4-1.38-6.95 4.01 2.4 1.38 6.95-4.01z",
    id: "el5pgbqt9y6w"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346 58.41-7 3.91-2.39-1.32 2.3 1.54c-.05.78 0 25.87.1 26.67.1-.8.15-25.94.1-26.7Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "341.305px 73.81px"
    },
    className: "animable",
    id: "elpmigf56q92"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "324.785px 85.31px"
    },
    id: "el2xfj7xnq8zq",
    className: "animable",
    d: "M325.98 96.78V75.22l-2.39-1.38v21.55l2.39 1.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "324.785px 85.31px"
    },
    className: "animable",
    d: "M325.98 96.78V75.22l-2.39-1.38v21.55l2.39 1.39z",
    id: "elvab699bdvo"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "329.455px 83.995px"
    },
    id: "elg7s49vysn5s",
    className: "animable",
    d: "m325.98 96.78 6.95-4.02V71.21l-6.95 4.01v21.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "329.455px 83.995px"
    },
    className: "animable",
    d: "m325.98 96.78 6.95-4.02V71.21l-6.95 4.01v21.56z",
    id: "elhj1xsjsdus"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "328.26px 72.525px"
    },
    id: "elmpht3amwohh",
    className: "animable",
    d: "m332.93 71.21-2.39-1.38-6.95 4.01 2.39 1.38 6.95-4.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      opacity: 0.55,
      transformOrigin: "328.26px 72.525px"
    },
    className: "animable",
    d: "m332.93 71.21-2.39-1.38-6.95 4.01 2.39 1.38 6.95-4.01z",
    id: "eldy4a3zehk9n"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.07 75.28 6.86-4.07-6.93 3.91c-.76-.43-2.39-1.28-2.39-1.28s1.53 1 2.3 1.43c0 .82 0 20.68.09 21.5 0-.77.1-20.71.07-21.49Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "328.27px 83.99px"
    },
    className: "animable",
    id: "elrjl0cx966"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "311.755px 94.565px"
    },
    id: "elwqn45buq5um",
    className: "animable",
    d: "M312.95 104.3V86.21l-2.39-1.38v18.08l2.39 1.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      transformOrigin: "311.755px 94.565px"
    },
    className: "animable",
    d: "M312.95 104.3V86.21l-2.39-1.38v18.08l2.39 1.39z",
    id: "els6yjdeytic"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "316.425px 93.25px"
    },
    id: "elks92a45jxqa",
    className: "animable",
    d: "m312.95 104.3 6.95-4.02V82.2l-6.95 4.01v18.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      transformOrigin: "316.425px 93.25px"
    },
    className: "animable",
    d: "m312.95 104.3 6.95-4.02V82.2l-6.95 4.01v18.09z",
    id: "eltrgnoz64l3q"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "315.23px 83.51px"
    },
    id: "elh687xe5rran",
    className: "animable",
    d: "m319.9 82.2-2.39-1.39-6.95 4.02 2.39 1.38 6.95-4.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      transformOrigin: "315.23px 83.51px"
    },
    className: "animable",
    d: "m319.9 82.2-2.39-1.39-6.95 4.02 2.39 1.38 6.95-4.01z",
    id: "elixohgukeipf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.9 82.2-6.9 3.9-2.39-1.27 2.3 1.5s0 17.47.09 18c.11-.5.11-18 .11-18Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "315.255px 93.265px"
    },
    className: "animable",
    id: "elzmyaxhe2h5o"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab-2--inject-138",
    className: "animable",
    style: {
      transformOrigin: "191.345px 300.55px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--donut-chart--inject-138",
    className: "animable",
    style: {
      transformOrigin: "191.345px 300.55px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "189.25px 298.398px"
    },
    className: "animable",
    id: "el9s9w6fsc8ks"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m149.34 256.42 79.82-46.05c.77-.44 1.4-.08 1.4.81V338a3.09 3.09 0 0 1-1.4 2.42l-79.82 46c-.78.45-1.4.09-1.4-.81V258.84a3.08 3.08 0 0 1 1.4-2.42Z",
    id: "elygzw27gzvu7",
    className: "animable",
    style: {
      transformOrigin: "189.25px 298.398px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m227.17 216.78-74 42.68a3.4 3.4 0 0 0-1.54 2.67v124.1a3.34 3.34 0 0 0 1.55 2.65l2.93 1.67a3.45 3.45 0 0 0 3.1 0l74-42.67a3.41 3.41 0 0 0 1.54-2.67V221.09a3.36 3.36 0 0 0-1.55-2.66l-2.94-1.66a3.43 3.43 0 0 0-3.09.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "193.19px 303.663px"
    },
    id: "elpy0ow0h2c0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.21 390.53a3.52 3.52 0 0 1-3.1 0l-2.93-1.67a3.34 3.34 0 0 1-1.55-2.65V262.13a3.17 3.17 0 0 1 .49-1.58l6 3.47a3 3 0 0 0-.46 1.52v124.1c0 .9.64 1.42 1.55.89Z",
    style: {
      opacity: 0.2,
      transformOrigin: "155.42px 325.72px"
    },
    className: "animable",
    id: "elde85aq9eza"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "193.425px 240.216px"
    },
    className: "animable",
    id: "el14mxschlz2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.73 220.81c-.12-.78-.75-1.06-1.52-.61l-74 42.67a3.18 3.18 0 0 0-1.09 1.15l-6-3.47a3.08 3.08 0 0 1 1.06-1.09l74-42.68a3.43 3.43 0 0 1 3.09 0l2.93 1.66a3.4 3.4 0 0 1 1.53 2.37Z",
    style: {
      fill: "#fff",
      transformOrigin: "193.425px 240.216px"
    },
    id: "elu4hdpxr2f2",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m233.21 220.2-74 42.67a3.4 3.4 0 0 0-1.55 2.67v124.1c0 1 .69 1.39 1.55.89l74-42.67a3.41 3.41 0 0 0 1.54-2.67v-124.1c0-.99-.69-1.38-1.54-.89Z",
    style: {
      fill: "#fff",
      transformOrigin: "196.205px 305.368px"
    },
    id: "el4jh1jw2wzjj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.52 221.44v123.75a2.21 2.21 0 0 1-.93 1.6l-73.69 42.5V265.54a2.23 2.23 0 0 1 .92-1.6l73.7-42.5m.38-1.45a1.33 1.33 0 0 0-.69.21l-74 42.67a3.4 3.4 0 0 0-1.55 2.67v124.1c0 .7.35 1.11.86 1.11a1.38 1.38 0 0 0 .69-.22l74-42.67a3.41 3.41 0 0 0 1.54-2.67v-124.1c0-.7-.35-1.1-.85-1.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "196.205px 305.37px"
    },
    id: "ela7tklqz9pj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.91 268.26v10.65c-4.6 2.66-8.33 9.79-8.33 15.93l-8 4.61c.01-12.02 7.32-25.99 16.33-31.19Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "174.745px 283.855px"
    },
    id: "elnplz3hm133",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.92 301.21-5.75 10.72c-3-2.42-4.58-6.71-4.58-12.48l8-4.61c-.01 3 .88 5.16 2.33 6.37Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "171.755px 303.385px"
    },
    id: "elpttd7fltkg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "171.755px 303.385px"
    },
    className: "animable",
    id: "eln8vufyzqc8s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m176.92 301.21-5.75 10.72c-3-2.42-4.58-6.71-4.58-12.48l8-4.61c-.01 3 .88 5.16 2.33 6.37Z",
    id: "elf6ge2apgy",
    className: "animable",
    style: {
      transformOrigin: "171.755px 303.385px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.24 280.6c0 12-7.31 26-16.33 31.2-4.69 2.7-8.48 2.74-11.74.13l5.75-10.72c1.51 1.22 3.64 1.29 6-.07 4.61-2.66 8.34-9.79 8.34-15.93s-3.73-9-8.34-6.3v-10.65c9.01-5.21 16.32.32 16.32 12.34Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "185.205px 290.078px"
    },
    id: "eljkjwpwi5c7j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "185.205px 290.078px"
    },
    className: "animable",
    id: "elhp8akw88ncb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.24 280.6c0 12-7.31 26-16.33 31.2-4.69 2.7-8.48 2.74-11.74.13l5.75-10.72c1.51 1.22 3.64 1.29 6-.07 4.61-2.66 8.34-9.79 8.34-15.93s-3.73-9-8.34-6.3v-10.65c9.01-5.21 16.32.32 16.32 12.34Z",
    style: {
      fill: "#fff",
      transformOrigin: "185.205px 290.078px"
    },
    id: "elsgv5x7mh81o",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m209.28 261.64-4.75 2.75a.21.21 0 0 0-.1.17v5.49c0 .06 0 .09.1.06l4.75-2.75a.19.19 0 0 0 .1-.16v-5.5c0-.06-.04-.09-.1-.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "206.905px 265.875px"
    },
    id: "el0zmtmi97jd7b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.28 261.64-4.75 2.75a.21.21 0 0 0-.1.17v5.49c0 .06 0 .09.1.06l4.75-2.75a.19.19 0 0 0 .1-.16v-5.5c0-.06-.04-.09-.1-.06Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "206.905px 265.875px"
    },
    className: "animable",
    id: "elvjch7c0m5i"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.8 261.58a.38.38 0 0 1-.31-.18.36.36 0 0 1 .13-.48l13.38-7.66a.35.35 0 1 1 .35.61L213 261.53a.34.34 0 0 1-.2.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "219.486px 257.397px"
    },
    id: "elkc1ejae9ho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.8 264.61a.35.35 0 0 1-.18-.66L226 256.3a.35.35 0 0 1 .48.13.35.35 0 0 1-.13.48L213 264.56a.34.34 0 0 1-.2.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "219.479px 260.432px"
    },
    id: "elzmvlq9qfgfh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.28 272.88-4.75 2.75a.21.21 0 0 0-.1.17v5.49c0 .06 0 .09.1.06l4.75-2.75a.19.19 0 0 0 .1-.16v-5.5c0-.06-.04-.09-.1-.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "206.905px 277.115px"
    },
    id: "eldfgiboqaa7u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.8 272.82a.38.38 0 0 1-.31-.18.36.36 0 0 1 .13-.48L226 264.5a.35.35 0 0 1 .48.13.35.35 0 0 1-.13.48L213 272.77a.34.34 0 0 1-.2.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "219.487px 268.637px"
    },
    id: "elasdthxm877n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.8 275.85a.35.35 0 0 1-.18-.66l13.38-7.65a.35.35 0 0 1 .48.13.35.35 0 0 1-.13.48L213 275.8a.34.34 0 0 1-.2.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "219.479px 271.672px"
    },
    id: "elpxlvm5234dh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.28 284.12-4.75 2.75a.21.21 0 0 0-.1.17v5.49c0 .06 0 .09.1.06l4.75-2.75a.19.19 0 0 0 .1-.16v-5.5c0-.06-.04-.09-.1-.06Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "206.905px 288.355px"
    },
    id: "elrwkhg2vsi3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.28 284.12-4.75 2.75a.21.21 0 0 0-.1.17v5.49c0 .06 0 .09.1.06l4.75-2.75a.19.19 0 0 0 .1-.16v-5.5c0-.06-.04-.09-.1-.06Z",
    style: {
      opacity: 0.3,
      transformOrigin: "206.905px 288.355px"
    },
    className: "animable",
    id: "elp06ulghhscf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.8 284.06a.38.38 0 0 1-.31-.18.35.35 0 0 1 .13-.48l13.38-7.66a.36.36 0 0 1 .48.13.35.35 0 0 1-.13.48L213 284a.34.34 0 0 1-.2.06Z",
    style: {
      fill: "#455a64",
      transformOrigin: "219.485px 279.878px"
    },
    id: "elds9709u4t6l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.8 287.09a.38.38 0 0 1-.31-.18.36.36 0 0 1 .13-.48l13.38-7.65a.35.35 0 0 1 .48.13.35.35 0 0 1-.13.48L213 287a.34.34 0 0 1-.2.09Z",
    style: {
      fill: "#455a64",
      transformOrigin: "219.487px 282.911px"
    },
    id: "el9g0txncpsl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.59 335.11a.37.37 0 0 1-.31-.17.35.35 0 0 1 .13-.48L226 300.12a.37.37 0 0 1 .48.13.36.36 0 0 1-.13.49l-59.53 34.33a.39.39 0 0 1-.23.04Z",
    style: {
      fill: "#455a64",
      transformOrigin: "196.38px 317.596px"
    },
    id: "eltssmxb51g5b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.59 341.27a.38.38 0 0 1-.31-.18.35.35 0 0 1 .13-.48L226 306.28a.35.35 0 1 1 .35.61l-59.53 34.33a.41.41 0 0 1-.23.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "196.38px 323.752px"
    },
    id: "el90hnvoybuwp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.59 347.42a.35.35 0 0 1-.18-.66L226 312.43a.35.35 0 1 1 .35.61l-59.53 34.33a.41.41 0 0 1-.23.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "196.374px 329.902px"
    },
    id: "eljosrao2onk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.59 353.57a.35.35 0 0 1-.18-.66L226 318.58a.36.36 0 0 1 .48.13.35.35 0 0 1-.13.48l-59.53 34.33a.41.41 0 0 1-.23.05Z",
    style: {
      fill: "#455a64",
      transformOrigin: "196.374px 336.054px"
    },
    id: "elr5xs39devis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.59 359.72a.35.35 0 0 1-.18-.66L226 324.73a.36.36 0 0 1 .48.13.35.35 0 0 1-.13.48l-59.53 34.34a.39.39 0 0 1-.23.04Z",
    style: {
      fill: "#455a64",
      transformOrigin: "196.374px 342.205px"
    },
    id: "elwnom24q5r6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.59 365.87a.37.37 0 0 1-.31-.17.35.35 0 0 1 .13-.48L226 330.88a.37.37 0 0 1 .48.13.36.36 0 0 1-.13.49l-59.53 34.33a.39.39 0 0 1-.23.04Z",
    style: {
      fill: "#455a64",
      transformOrigin: "196.38px 348.356px"
    },
    id: "elfebpq5pon4",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--user-icons--inject-138",
    className: "animable animator-active",
    style: {
      transformOrigin: "237.585px 125.49px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft,1.5s Infinite linear heartbeat",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-icon--inject-138",
    className: "animable",
    style: {
      transformOrigin: "264.585px 109.907px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "262.49px 107.774px"
    },
    className: "animable",
    id: "el8kr8v3eif0k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m242.81 96.82 39.36-22.73c.77-.45 1.4-.09 1.4.8v41.42a3.1 3.1 0 0 1-1.4 2.42l-39.36 22.73c-.77.45-1.4.08-1.4-.81V99.24a3.09 3.09 0 0 1 1.4-2.42Z",
    id: "el8s0fesnm3cg",
    className: "animable",
    style: {
      transformOrigin: "262.49px 107.774px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "266.43px 113.02px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m280.18 80.5-33.54 19.35a3.41 3.41 0 0 0-1.54 2.67v38.71a3.34 3.34 0 0 0 1.55 2.65l2.94 1.67a3.43 3.43 0 0 0 3.09 0l33.54-19.35a3.41 3.41 0 0 0 1.54-2.67V84.8a3.34 3.34 0 0 0-1.55-2.65l-2.94-1.67a3.43 3.43 0 0 0-3.09.02Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "266.43px 113.02px"
    },
    id: "el4elh1qip4mp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.68 145.53a3.52 3.52 0 0 1-3.1 0l-2.93-1.67a3.37 3.37 0 0 1-1.55-2.65v-38.69a3.17 3.17 0 0 1 .49-1.57l6 3.47a3.13 3.13 0 0 0-.45 1.52v38.7c0 .9.63 1.42 1.54.89Z",
    style: {
      opacity: 0.2,
      transformOrigin: "248.89px 123.42px"
    },
    className: "animable",
    id: "elb6kt59k6z6i"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "266.665px 92.2712px"
    },
    className: "animable",
    id: "eljpfudq9dgz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.74 84.52c-.12-.77-.75-1-1.52-.61l-33.54 19.36a3.18 3.18 0 0 0-1.09 1.15l-6-3.47a3.2 3.2 0 0 1 1.06-1.1l33.55-19.36a3.43 3.43 0 0 1 3.09 0l2.93 1.66a3.4 3.4 0 0 1 1.52 2.37Z",
    style: {
      fill: "#fff",
      transformOrigin: "266.665px 92.2712px"
    },
    id: "elkseofjh52fh",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m286.22 83.91-33.54 19.36a3.4 3.4 0 0 0-1.54 2.67v38.7c0 1 .69 1.39 1.54.89l33.54-19.35a3.41 3.41 0 0 0 1.54-2.67V84.8c0-.98-.69-1.38-1.54-.89Z",
    style: {
      fill: "#fff",
      transformOrigin: "269.45px 114.724px"
    },
    id: "elpwv74mpaxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.53 85.16v38.35a2.21 2.21 0 0 1-.93 1.6l-33.23 19.18v-38.35a2.21 2.21 0 0 1 .93-1.6l33.23-19.18m.38-1.46a1.43 1.43 0 0 0-.69.21l-33.54 19.36a3.4 3.4 0 0 0-1.54 2.67v38.7c0 .7.34 1.1.85 1.1a1.33 1.33 0 0 0 .69-.21l33.54-19.35a3.41 3.41 0 0 0 1.54-2.67V84.8c0-.7-.35-1.1-.85-1.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "269.45px 114.72px"
    },
    id: "elfwhiw2n4oe",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m260.21 135.33 21.47-12.39-.36-3.09a5 5 0 0 0-2.12-4l-3-1.73a4.06 4.06 0 0 0-4.14.34l-8.23 4.75c-3.15 1.82-5.82 6.46-6.27 10.87l-.35 3.5Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "269.445px 124.518px"
    },
    id: "elh5y8m78raiv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.59 102.72c1.06.61 1.71 1.92 1.71 3.79a12.92 12.92 0 0 1-5.84 10.11c-1.62.94-3.08 1-4.13.41l-2.94-1.69c-1.05-.61-1.71-1.92-1.71-3.78a12.92 12.92 0 0 1 5.84-10.12c1.62-.93 3.08-1 4.13-.41Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "269.99px 109.032px"
    },
    id: "el98mjgtrr2o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.32 119.85a5 5 0 0 0-2.12-4 4 4 0 0 0-4.14.33l-8.24 4.82c-3.15 1.82-5.82 6.46-6.26 10.88l-.35 3.49 21.47-12.39Zm-14-2.82c1.05.61 2.51.53 4.13-.41a12.92 12.92 0 0 0 5.84-10.11c0-1.87-.65-3.18-1.71-3.79s-2.52-.52-4.13.41a12.91 12.91 0 0 0-5.84 10.12c.01 1.86.66 3.17 1.72 3.75Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "270.945px 118.851px"
    },
    id: "el5kzelsd8i8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.32 119.85a5 5 0 0 0-2.12-4 4 4 0 0 0-4.14.33l-8.24 4.82c-3.15 1.82-5.82 6.46-6.26 10.88l-.35 3.49 21.47-12.39Zm-14-2.82c1.05.61 2.51.53 4.13-.41a12.92 12.92 0 0 0 5.84-10.11c0-1.87-.65-3.18-1.71-3.79s-2.52-.52-4.13.41a12.91 12.91 0 0 0-5.84 10.12c.01 1.86.66 3.17 1.72 3.75Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      transformOrigin: "270.945px 118.851px"
    },
    className: "animable",
    id: "el8uajq6m32qx"
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "210.585px 141.08px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "208.485px 138.954px"
    },
    className: "animable",
    id: "el0hq04jmcz33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m188.81 128 39.36-22.73c.77-.45 1.39-.09 1.39.8v41.41a3.1 3.1 0 0 1-1.39 2.43l-39.36 22.73c-.78.45-1.4.08-1.4-.81v-41.42a3.06 3.06 0 0 1 1.4-2.41Z",
    id: "el5fwcz0r0eq",
    className: "animable",
    style: {
      transformOrigin: "208.485px 138.954px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "212.43px 144.188px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.18 111.66 192.64 131a3.41 3.41 0 0 0-1.54 2.67v38.73a3.34 3.34 0 0 0 1.55 2.65l2.93 1.67a3.48 3.48 0 0 0 3.1 0l33.54-19.35a3.41 3.41 0 0 0 1.54-2.67V116a3.37 3.37 0 0 0-1.55-2.65l-2.94-1.67a3.46 3.46 0 0 0-3.09-.02Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "212.43px 144.195px"
    },
    id: "el36yfobfv0ks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.68 176.7a3.52 3.52 0 0 1-3.1 0l-2.93-1.67a3.34 3.34 0 0 1-1.55-2.65v-38.69a3.17 3.17 0 0 1 .49-1.57l6 3.47a3 3 0 0 0-.46 1.52v38.7c0 .9.64 1.42 1.55.89Z",
    style: {
      opacity: 0.2,
      transformOrigin: "194.89px 154.59px"
    },
    className: "animable",
    id: "elgl97halrkha"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "212.665px 123.441px"
    },
    className: "animable",
    id: "elnq03vo7o8tr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.74 115.69c-.12-.78-.76-1-1.53-.61l-33.53 19.36a3.18 3.18 0 0 0-1.09 1.15l-6-3.47a3.12 3.12 0 0 1 1.06-1.1l33.54-19.36a3.43 3.43 0 0 1 3.09 0l2.94 1.66a3.43 3.43 0 0 1 1.52 2.37Z",
    style: {
      fill: "#fff",
      transformOrigin: "212.665px 123.441px"
    },
    id: "elfeo5psqt2xa",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m232.22 115.08-33.54 19.36a3.38 3.38 0 0 0-1.55 2.67v38.7c0 1 .69 1.38 1.55.89l33.54-19.35a3.41 3.41 0 0 0 1.54-2.67V116c0-1-.69-1.41-1.54-.92Z",
    style: {
      fill: "#fff",
      transformOrigin: "215.445px 145.893px"
    },
    id: "eljtta9a2lc3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.52 116.33v38.35a2.2 2.2 0 0 1-.92 1.6l-33.23 19.18v-38.35a2.21 2.21 0 0 1 .92-1.6l33.23-19.18m.38-1.46a1.4 1.4 0 0 0-.68.21l-33.54 19.36a3.38 3.38 0 0 0-1.55 2.67v38.7c0 .7.35 1.1.86 1.1a1.36 1.36 0 0 0 .69-.21l33.54-19.35a3.41 3.41 0 0 0 1.54-2.67V116c0-.7-.35-1.1-.86-1.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "215.445px 145.89px"
    },
    id: "elp4olgr2nk2i",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m206.2 166.57 21.47-12.4-.35-3.09a5 5 0 0 0-2.12-4l-3-1.73a4.06 4.06 0 0 0-4.14.34l-8.23 4.75c-3.16 1.82-5.83 6.46-6.27 10.87l-.35 3.5Z",
    style: {
      fill: "#263238",
      transformOrigin: "215.44px 155.753px"
    },
    id: "elym8f7o4pvkc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.32 151.08a5 5 0 0 0-2.12-4 4.05 4.05 0 0 0-4.15.33l-8.23 4.75c-3.15 1.83-5.82 6.46-6.27 10.88l-.35 3.5 21.47-12.4Z",
    style: {
      fill: "#455a64",
      transformOrigin: "216.935px 156.599px"
    },
    id: "elhkw5d22yi2w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.58 134c1.06.61 1.72 1.92 1.72 3.79a12.9 12.9 0 0 1-5.85 10.11c-1.61.94-3.07 1-4.13.41l-2.93-1.69c-1.06-.61-1.71-1.92-1.71-3.78a12.89 12.89 0 0 1 5.84-10.12c1.61-.93 3.07-1 4.13-.41Z",
    style: {
      fill: "#263238",
      transformOrigin: "215.99px 140.312px"
    },
    id: "el6wpr3l5dbpf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.45 147.85c-1.61.94-3.07 1-4.13.41s-1.71-1.92-1.71-3.78a13 13 0 0 1 5.84-10.12c1.62-.93 3.08-1 4.13-.41s1.72 1.92 1.72 3.79a12.9 12.9 0 0 1-5.85 10.11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "217.455px 141.107px"
    },
    id: "elv7g9p1d0mpn",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tab-1--inject-138",
    className: "animable",
    style: {
      transformOrigin: "119.88px 213.851px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "119.88px 213.851px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "113.78px 210.087px"
    },
    className: "animable",
    id: "elacbc9p2oyk6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.21 144.25v71.22a5.84 5.84 0 0 1-2.65 4.59L64 277.55a1.74 1.74 0 0 1-.88.25 1.33 1.33 0 0 1-.34-.05.81.81 0 0 1-.22-.07 1.55 1.55 0 0 1-.24-.13 2.15 2.15 0 0 1-.69-.88 3.16 3.16 0 0 1-.28-1.34v-70.58a5.89 5.89 0 0 1 2.65-4.59l99.58-57.44a1.91 1.91 0 0 1 1.78-.22.76.76 0 0 1 .23.13.77.77 0 0 1 .18.18.73.73 0 0 1 .08.09.5.5 0 0 1 .08.14 1.5 1.5 0 0 1 .16.34.86.86 0 0 1 .06.23.07.07 0 0 1 0 .06 1.5 1.5 0 0 1 0 .24c.05.09.06.23.06.34Z",
    id: "el1djp02gpw3p",
    className: "animable",
    style: {
      transformOrigin: "113.78px 210.087px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.41 151.77V223a5.84 5.84 0 0 1-2.65 4.58l-99.59 57.49a1.68 1.68 0 0 1-.87.25 1.86 1.86 0 0 1-.34 0l-.23-.08-.23-.12a2.37 2.37 0 0 1-.7-.89 3.32 3.32 0 0 1-.28-1.34v-70.62a5.86 5.86 0 0 1 2.65-4.58l99.59-57.45a1.9 1.9 0 0 1 1.78-.22 1 1 0 0 1 .22.13 1 1 0 0 1 .17.18.23.23 0 0 1 .08.09.55.55 0 0 1 .09.14 1.5 1.5 0 0 1 .16.34 1.4 1.4 0 0 1 .06.24 1.72 1.72 0 0 1 0 .24c.08.17.09.28.09.39Z",
    style: {
      fill: "#fff",
      transformOrigin: "125.965px 217.61px"
    },
    id: "el2pz3oehib79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.93 150.83a.46.46 0 0 1 .21 0h.05l.07.09.06.09.1.29v.1a2 2 0 0 1 0 .25V223a4.9 4.9 0 0 1-2.18 3.77l-99.53 57.48a.77.77 0 0 1-.41.13h-.15l-.11-.05a2 2 0 0 1-.35-.51 2.33 2.33 0 0 1-.18-.92v-70.63a5 5 0 0 1 2.18-3.77l99.58-57.44a1.52 1.52 0 0 1 .71-.23m0-.94a2.39 2.39 0 0 0-1.17.35l-99.64 57.45a5.86 5.86 0 0 0-2.65 4.58v70.58a3.32 3.32 0 0 0 .28 1.34 2.37 2.37 0 0 0 .7.89l.23.12.23.08a1.86 1.86 0 0 0 .34 0 1.79 1.79 0 0 0 .84-.25l99.59-57.49a5.84 5.84 0 0 0 2.65-4.58v-71.52a1.72 1.72 0 0 0 0-.24 1.4 1.4 0 0 0-.06-.24 1.5 1.5 0 0 0-.16-.34.55.55 0 0 0-.09-.14.23.23 0 0 0-.08-.09 1 1 0 0 0-.17-.18 1 1 0 0 0-.22-.13 1.39 1.39 0 0 0-.61-.13Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "125.952px 217.589px"
    },
    id: "elnoae5jxlsqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.54 150a1.9 1.9 0 0 0-1.78.22l-99.59 57.47a5.86 5.86 0 0 0-2.65 4.58v8.65L66.73 217v-8.59a5.83 5.83 0 0 1 2.64-4.58L169 146.4a1.84 1.84 0 0 1 1.92-.16c.44.29 6.08 3.48 6.62 3.76Z",
    style: {
      fill: "#37474f",
      transformOrigin: "122.135px 183.481px"
    },
    id: "elpewnrak23wq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4 151.75c0-1.67-1.19-2.34-2.64-1.5l-99.59 57.44a5.83 5.83 0 0 0-2.64 4.58v8.66l104.87-60.49Z",
    style: {
      fill: "#455a64",
      transformOrigin: "125.965px 185.409px"
    },
    id: "elr2gtz95iivi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.73 217v-8.6a5.46 5.46 0 0 1 .8-2.65l6.79 3.87a5.41 5.41 0 0 0-.79 2.63v8.66Z",
    style: {
      fill: "#263238",
      transformOrigin: "70.525px 213.33px"
    },
    id: "el1lc33x73hjn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.39 161.05a3.92 3.92 0 0 0-1.5 3.16c0 1.27.67 1.92 1.5 1.44a4 4 0 0 0 1.49-3.17c0-1.27-.67-1.91-1.49-1.43Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "163.385px 163.349px"
    },
    id: "eli1pkcwxklc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.77 157.93a4 4 0 0 0-1.5 3.17c0 1.27.67 1.91 1.5 1.44a4 4 0 0 0 1.49-3.17c0-1.27-.67-1.91-1.49-1.44Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "168.765px 160.235px"
    },
    id: "el28rurtzlepz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.15 154.82a4 4 0 0 0-1.49 3.16c0 1.28.67 1.92 1.49 1.44a3.92 3.92 0 0 0 1.5-3.16c0-1.26-.65-1.92-1.5-1.44Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "174.155px 157.121px"
    },
    id: "eloaxzrb3xvvs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.5 285.08-.33-.19-6.33-3.64a2.37 2.37 0 0 1-.81-.9 3.31 3.31 0 0 1-.3-1.4V217l6.79 3.91v61.93a3.69 3.69 0 0 0 .28 1.34 2.35 2.35 0 0 0 .7.9Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "70.615px 251.04px"
    },
    id: "elp48sdfm36lj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "125.965px 207.95px"
    },
    id: "elufzy08ze2l9",
    className: "animable",
    d: "m173.2 192.71-94.47 54.51v-24.04l94.47-54.5v24.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "111.04px 245.805px"
    },
    id: "eldrgf8blo5k",
    className: "animable",
    d: "m143.35 239.2-64.62 37.24v-24.03l64.62-37.24v24.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "161.025px 216.73px"
    },
    id: "elosmj6n01s2n",
    className: "animable",
    d: "m173.2 221.73-24.35 14.03v-24.03l24.35-14.03v24.03z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-138",
    className: "animable",
    style: {
      transformOrigin: "110.17px 83.515px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Title--inject-138",
    className: "animable",
    style: {
      transformOrigin: "110.17px 83.515px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.42 57.8V101a2.41 2.41 0 0 1-1 1.78l-45.3 26.13V85.73a2.41 2.41 0 0 1 1-1.78l45.3-26.15m.32-1.41a1.48 1.48 0 0 0-.73.22L40.53 82.88a3.66 3.66 0 0 0-1.64 2.85v43.42c0 .75.37 1.18.91 1.18a1.51 1.51 0 0 0 .73-.23L86 103.83a3.65 3.65 0 0 0 1.65-2.83V57.56c0-.74-.37-1.17-.91-1.17Z",
    style: {
      fill: "#455a64",
      transformOrigin: "63.27px 93.36px"
    },
    id: "el20ywfpnx2xe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.35 25.38-117 67.55a3.63 3.63 0 0 0-1.65 2.85v41.28a3.58 3.58 0 0 0 1.66 2.83l3.13 1.77a3.66 3.66 0 0 0 3.29 0l117-67.56a3.61 3.61 0 0 0 1.65-2.84V30a3.56 3.56 0 0 0-1.66-2.83l-3.13-1.78a3.65 3.65 0 0 0-3.29-.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "118.065px 83.5219px"
    },
    id: "el875wr4b067i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.35 25.38-117 67.55a3.63 3.63 0 0 0-1.65 2.85v41.28a3.58 3.58 0 0 0 1.66 2.83l3.13 1.77a3.66 3.66 0 0 0 3.29 0l117-67.56a3.61 3.61 0 0 0 1.65-2.84V30a3.56 3.56 0 0 0-1.66-2.83l-3.13-1.78a3.65 3.65 0 0 0-3.29-.01Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "118.065px 83.5219px"
    },
    className: "animable",
    id: "el6w1irvdpb2v"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8 141.65a3.78 3.78 0 0 1-3.3 0l-3.12-1.79a3.56 3.56 0 0 1-1.66-2.82V95.78a3.38 3.38 0 0 1 .53-1.68l6.4 3.7a3.24 3.24 0 0 0-.49 1.62v41.28c0 .96.68 1.51 1.64.95Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.5,
      transformOrigin: "58.76px 118.065px"
    },
    className: "animable",
    id: "elkl45mn2hvt9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.41 29.67c-.13-.83-.8-1.12-1.62-.65l-117 67.55a3.36 3.36 0 0 0-1.16 1.23l-6.41-3.7a3.26 3.26 0 0 1 1.13-1.17l117-67.56a3.66 3.66 0 0 1 3.29 0l3.13 1.77a3.61 3.61 0 0 1 1.64 2.53Z",
    style: {
      fill: "#b0bec5",
      opacity: 0.3,
      transformOrigin: "118.315px 61.3898px"
    },
    className: "animable",
    id: "el5y88unmavcr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.79 29 62.8 96.57a3.66 3.66 0 0 0-1.64 2.85v41.28c0 1.05.74 1.47 1.64 1l117-67.56a3.61 3.61 0 0 0 1.65-2.84V30c-.01-1.08-.75-1.51-1.66-1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "121.305px 85.3388px"
    },
    id: "eleokmsjxhvv9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.79 29 62.8 96.57a3.66 3.66 0 0 0-1.64 2.85v41.28c0 1.05.74 1.47 1.64 1l117-67.56a3.61 3.61 0 0 0 1.65-2.84V30c-.01-1.08-.75-1.51-1.66-1Z",
    style: {
      fill: "#fff",
      opacity: 0.8,
      transformOrigin: "121.305px 85.3388px"
    },
    className: "animable",
    id: "elbt7dy54stpr"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "121.305px 85.33px"
    },
    className: "animable",
    id: "elhe6jk2vcocf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180 30.51v40.74a2.25 2.25 0 0 1-.93 1.62l-116.5 67.28V99.42a2.24 2.24 0 0 1 .94-1.62L180 30.51m.51-1.72a1.57 1.57 0 0 0-.74.23L62.8 96.57a3.66 3.66 0 0 0-1.64 2.85v41.28c0 .74.37 1.17.91 1.17a1.48 1.48 0 0 0 .73-.22l117-67.56a3.61 3.61 0 0 0 1.65-2.84V30c0-.75-.37-1.18-.91-1.18Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "121.305px 85.33px"
    },
    id: "elm4xrg4vaur",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.68 87.76a9.64 9.64 0 0 1 3.74-1.4 3.68 3.68 0 0 1 2.65.62 4.94 4.94 0 0 1 1.63 2.44 14.71 14.71 0 0 1 .69 4c.07 1.87.07 3.79 0 5.75a25.11 25.11 0 0 1-.69 4.82 19.84 19.84 0 0 1-1.61 4.31 16.73 16.73 0 0 1-2.61 3.7 16.22 16.22 0 0 1-3.65 2.86l-7.34 4.24a.48.48 0 0 1-.55 0 .71.71 0 0 1-.24-.61V93.42a1.85 1.85 0 0 1 .24-.88 1.57 1.57 0 0 1 .55-.63Zm4.78 8a7.38 7.38 0 0 0-.37-2.1 2.7 2.7 0 0 0-.9-1.34 2.12 2.12 0 0 0-1.5-.38 5.42 5.42 0 0 0-2.15.8L90.63 95v17.47l4.05-2.34a8.42 8.42 0 0 0 2.07-1.64 9.71 9.71 0 0 0 1.45-2.06 10 10 0 0 0 .89-2.38 12.87 12.87 0 0 0 .37-2.54c.07-2 .07-3.92 0-5.79Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "95.0693px 102.753px"
    },
    id: "elnek28nmztpi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.34 75.26c.31-.18.55-.21.7-.08a1.6 1.6 0 0 1 .41.76l7.13 20.41a.93.93 0 0 1 0 .26 2 2 0 0 1-.23.87 1.51 1.51 0 0 1-.55.63l-2.1 1.21c-.39.22-.66.27-.82.14a1 1 0 0 1-.32-.46l-1.25-3.58-9.2 5.31-1.25 5a4.47 4.47 0 0 1-.32.83 2 2 0 0 1-.82.8l-2.09 1.21a.5.5 0 0 1-.56 0 .74.74 0 0 1-.23-.61 1.36 1.36 0 0 1 0-.29L112 79.06a6.16 6.16 0 0 1 .41-1.22 1.78 1.78 0 0 1 .7-.74Zm1.6 16.11-3.2-9.21-3.2 12.91Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "114.711px 91.8779px"
    },
    id: "eldfa7phlh1aa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.76 62.31a.48.48 0 0 1 .55 0 .71.71 0 0 1 .24.61v2.75a1.79 1.79 0 0 1-.24.87 1.45 1.45 0 0 1-.55.63l-5.24 3v21.29a2 2 0 0 1-.23.88 1.59 1.59 0 0 1-.56.63l-2.35 1.36a.5.5 0 0 1-.56 0 .74.74 0 0 1-.23-.61V72.46l-5.24 3a.46.46 0 0 1-.55 0 .68.68 0 0 1-.24-.6v-2.73a1.85 1.85 0 0 1 .24-.87 1.5 1.5 0 0 1 .55-.63Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "131.555px 78.3196px"
    },
    id: "elsexlw2nsdyp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 55.84c.31-.18.54-.2.7-.07a1.7 1.7 0 0 1 .41.75l7.13 20.42a.85.85 0 0 1 0 .25 1.89 1.89 0 0 1-.23.87 1.46 1.46 0 0 1-.56.63l-2.09 1.21c-.39.23-.66.28-.82.15a1 1 0 0 1-.32-.46L153 76l-9.2 5.32-1.25 5a4.4 4.4 0 0 1-.32.82 2 2 0 0 1-.82.8l-2.1 1.21a.45.45 0 0 1-.55 0 .71.71 0 0 1-.23-.6 1.36 1.36 0 0 1 0-.29l7.13-28.65a5.5 5.5 0 0 1 .41-1.23 1.7 1.7 0 0 1 .7-.73ZM151.57 72l-3.2-9.22-3.2 12.92Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "148.386px 72.465px"
    },
    id: "el4x7bkd7uhtc",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-138",
    className: "animable",
    style: {
      transformOrigin: "84.485px 357.301px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-138",
    className: "animable",
    style: {
      transformOrigin: "84.485px 357.301px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-138",
    className: "animable",
    style: {
      transformOrigin: "84.485px 357.301px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-138",
    className: "animable",
    style: {
      transformOrigin: "78.8339px 402.261px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.25 397.56H48.36l6.29 26.23c.48 3.16 2.81 6.25 7 8.67 9.47 5.47 24.82 5.47 34.29 0 4.52-2.61 6.85-6 7.06-9.4Z",
    style: {
      fill: "#37474f",
      transformOrigin: "78.805px 417.061px"
    },
    id: "elottsei6rgz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.82 415.54a26.44 26.44 0 0 0 3.66-2.55l3.42-14a24.57 24.57 0 0 1-6.16 4.9c-12.84 7.41-33.43 7.6-46.71.6l1.54-6.25-.47-.66h-8.74l6.29 26.22c.48 3.16 2.81 6.25 7 8.67 6.75 3.89 16.47 5 24.93 3.34-15.17 1.14-25.58-5.5-27.14-11.61-.62-2.44-1.71-7.84-1.71-7.84 12.68 6.41 31.99 6.16 44.09-.82Z",
    style: {
      fill: "#263238",
      transformOrigin: "78.63px 417.068px"
    },
    id: "elia6bacehenh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.41 389.8a12.8 12.8 0 0 1-2 4.74 22.46 22.46 0 0 1-7.64 6.78c-13.21 7.63-34.65 7.63-47.87 0a22.46 22.46 0 0 1-7.64-6.78 13 13 0 0 1-2-4.74c-1.18-5.73 2-11.71 9.67-16.11 13.22-7.64 34.66-7.64 47.87 0 7.56 4.4 10.79 10.38 9.61 16.11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "78.8339px 387.501px"
    },
    id: "elb3rznvrobmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.38 394.54a22.46 22.46 0 0 1-7.64 6.78c-13.21 7.63-34.65 7.63-47.87 0a22.46 22.46 0 0 1-7.64-6.78 13 13 0 0 1-2-4.74l1.5 10.32c.69 4.16 3.78 8.2 9.3 11.38 12.6 7.27 33 7.27 45.61 0 5.44-3.14 8.54-7.13 9.27-11.23l.08-.53 1.45-9.94a12.8 12.8 0 0 1-2.06 4.74Z",
    style: {
      fill: "#37474f",
      transformOrigin: "78.835px 403.376px"
    },
    id: "elsrjuam6k8kj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.76 376c-11-6.37-28.88-6.37-39.89 0-6.24 3.6-8.94 8.46-8.12 13.15.63 3.61 3.34 7.11 8.12 9.87 11 6.37 28.87 6.37 39.89 0 4.77-2.76 7.48-6.26 8.11-9.86.82-4.71-1.87-9.57-8.11-13.16Z",
    style: {
      fill: "#263238",
      transformOrigin: "78.8102px 387.51px"
    },
    id: "el0f8gdbzu9agg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.61 393.51a19 19 0 0 0 6.26 5.5c11 6.37 28.87 6.37 39.89 0a19 19 0 0 0 6.25-5.5c-.08-3.81-2.63-7.61-7.67-10.51-10.23-5.92-26.83-5.92-37.06 0-5.04 2.91-7.59 6.7-7.67 10.51Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "78.81px 391.174px"
    },
    id: "elhgyo435c5om",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-138",
    className: "animable",
    style: {
      transformOrigin: "84.485px 337.807px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m101.27 298.28-17.36 14.89 17-8.66A47.86 47.86 0 0 1 98.55 321s-8.33 5.42-13.11 10.08l13.07-5.76s1.25 8.72-1.88 22.21c-.81 3.54-4.48 10.36-6.77 15.45a57.09 57.09 0 0 1-3.6 6.81l-.25.41q-4.67-2.43-9.66-4.68c-2.31-4.41-5.52-15.39-6.88-24.43-5.17-34.61 20.35-55.55 41.22-63.05 0 .03-6.91 9.42-9.42 20.24Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "89.742px 324.12px"
    },
    id: "ely6cac1ci56h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.35 300.31c-3.51 3.82-5.46 8.74-6.92 13.64a71 71 0 0 0-2.59 15.16 65.18 65.18 0 0 0 5 30 .5.5 0 0 1-.26.66.51.51 0 0 1-.67-.26 65.9 65.9 0 0 1-4.54-30.47 71.3 71.3 0 0 1 2.86-15.2c1.5-4.84 3.55-9.77 7.12-13.53Z",
    style: {
      fill: "#fff",
      transformOrigin: "81.2325px 330.061px"
    },
    id: "eleus12xa3rvo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.32 315.22c.4.62 7 10.82 16.29 30.21l18.79 5.48-14.4.74 6.09 13 15 4.14-11.63 2.68s2.29 14.89 12.09 22.21c5.41 4 7.93 4.43 10.15 3.45 2.72-1.19 4.44-5.17 6.22-11.2s1.2-18.73-3.1-31.54a38 38 0 0 0-4.93-9.63c-12.07-17.32-37.51-28.1-50.57-29.54Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "54.0919px 356.397px"
    },
    id: "elj6a67xqy9xn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.32 315.22c.4.62 7 10.82 16.29 30.21l18.79 5.48-14.4.74 6.09 13 15 4.14-11.63 2.68s2.29 14.89 12.09 22.21c5.41 4 7.93 4.43 10.15 3.45 2.72-1.19 4.44-5.17 6.22-11.2s1.2-18.73-3.1-31.54a38 38 0 0 0-4.93-9.63c-12.07-17.32-37.51-28.1-50.57-29.54Z",
    style: {
      opacity: 0.1,
      transformOrigin: "54.0919px 356.397px"
    },
    className: "animable",
    id: "el822dd7ecrct"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6 324c9.37 5.58 18 12.73 24.37 21.75a52.87 52.87 0 0 1 7.44 14.7 50 50 0 0 1 2.2 16.28h-.1a64.59 64.59 0 0 0-3.12-16 59.29 59.29 0 0 0-7.12-14.54c-6.12-9-14.53-16.31-23.73-22.15a.06.06 0 0 1 0-.08.06.06 0 0 1 .06.04Z",
    style: {
      fill: "#fff",
      transformOrigin: "60.5791px 350.345px"
    },
    id: "elrb7b2d3jns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64 318.36a47.09 47.09 0 0 0-5.73.26A91.6 91.6 0 0 0 117 324c-2.62 1-5.25 2.08-7.84 3.32-1.29.62-2.57 1.27-3.83 2a63.49 63.49 0 0 0-16.81 12.71 39.88 39.88 0 0 0-5.79 8.13c-.2.38-.42.75-.61 1.14-.49 1-.93 2-1.34 2.95-4.85 11-5.26 18.57-4.95 27 .24 6.54 2.46 14 3.73 15.25a3.8 3.8 0 0 0 .57.42c1.87 1.19 4.83.49 10.38-2.61 11.11-6.21 15.47-22 15.47-22l-15-3.42 19.36-3.16 8.05-12.56-14.81-2.69 20.14-3.1c12.21-18.75 20.41-28.38 20.91-29Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "110.196px 357.911px"
    },
    id: "elcua4gdauvjg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.91 318.62A91.6 91.6 0 0 0 117 324c-2.62 1-5.25 2.08-7.84 3.32-1.29.62-2.57 1.27-3.83 2a63.49 63.49 0 0 0-16.81 12.71 39.88 39.88 0 0 0-5.79 8.13c-.2.38-.42.75-.61 1.14-.49 1-.93 2-1.34 2.95-4.85 11-5.26 18.57-4.95 27 .24 6.54 2.46 14 3.73 15.25a3.8 3.8 0 0 0 .57.42 3.55 3.55 0 0 0 1.23.45c-1.37-10.14 3.61-35.86 11.17-46.44 7.86-11 26.5-27 52.12-32.46a48.28 48.28 0 0 0-5.74.15Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "110.201px 357.907px"
    },
    id: "el5l73g07yf23",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.91 318.62A91.6 91.6 0 0 0 117 324c-2.62 1-5.25 2.08-7.84 3.32-1.29.62-2.57 1.27-3.83 2a63.49 63.49 0 0 0-16.81 12.71 39.88 39.88 0 0 0-5.79 8.13c-.2.38-.42.75-.61 1.14-.49 1-.93 2-1.34 2.95-4.85 11-5.26 18.57-4.95 27 .24 6.54 2.46 14 3.73 15.25a3.8 3.8 0 0 0 .57.42 3.55 3.55 0 0 0 1.23.45c-1.37-10.14 3.61-35.86 11.17-46.44 7.86-11 26.5-27 52.12-32.46a48.28 48.28 0 0 0-5.74.15Z",
    style: {
      opacity: 0.2,
      transformOrigin: "110.201px 357.907px"
    },
    className: "animable",
    id: "el2n58k9jwoh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.25 397.29a87.07 87.07 0 0 1 1.46-22.43 72.2 72.2 0 0 1 7.44-21.27c3.8-6.62 9.25-12 15.06-16.81a84 84 0 0 1 19.32-11.58.07.07 0 0 1 .09 0 .07.07 0 0 1 0 .08A110.73 110.73 0 0 0 106 337.75a81.59 81.59 0 0 0-8.17 7.6A50 50 0 0 0 91 354.1a71.69 71.69 0 0 0-7.67 20.9 86.46 86.46 0 0 0-2 22.29s0 .07-.06.07a.07.07 0 0 1-.02-.07Z",
    style: {
      fill: "#fff",
      transformOrigin: "102.851px 361.272px"
    },
    id: "eluowo27ojmyo",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-138",
    className: "animable",
    style: {
      transformOrigin: "257.041px 408.561px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glass--inject-138",
    className: "animable",
    style: {
      transformOrigin: "257.041px 408.561px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.73 408a2.93 2.93 0 0 1-3-.29 9.21 9.21 0 0 1-4.19-7.22 2.91 2.91 0 0 1 1.22-2.7l51.95-32.86c1.07-.72 2.59-.68 4.28.29a12.92 12.92 0 0 1 5.86 10.1c0 1.95-.72 3.29-1.87 3.86Z",
    style: {
      fill: "#455a64",
      transformOrigin: "300.186px 386.36px"
    },
    id: "elx53n0mazan8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.58 400.47c0-2.66 1.86-3.74 4.17-2.42a9.21 9.21 0 0 1 4.19 7.22c0 2.67-1.86 3.75-4.17 2.42a9.21 9.21 0 0 1-4.19-7.22Z",
    style: {
      fill: "#37474f",
      transformOrigin: "272.76px 402.873px"
    },
    id: "el3ggvz0acltj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.44 411.8a5.6 5.6 0 0 1-2.53-4.37 1.78 1.78 0 0 1 .74-1.64l10.32-6a1.77 1.77 0 0 1 1.79.17 5.58 5.58 0 0 1 2.53 4.37 1.76 1.76 0 0 1-.74 1.63l-10.32 6a1.79 1.79 0 0 1-1.79-.16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "267.6px 405.875px"
    },
    id: "ell6urd5ipvv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.44 411.8a5.6 5.6 0 0 1-2.53-4.37 1.78 1.78 0 0 1 .74-1.64l10.32-6a1.77 1.77 0 0 1 1.79.17 5.58 5.58 0 0 1 2.53 4.37 1.76 1.76 0 0 1-.74 1.63l-10.32 6a1.79 1.79 0 0 1-1.79-.16Z",
    style: {
      opacity: 0.2,
      transformOrigin: "267.6px 405.875px"
    },
    className: "animable",
    id: "el9kagm82mmym"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.3 403.48-1.18-.87-5.44 3.16a31.27 31.27 0 0 1 6.05 4.74l5-2.89c-.13-.16-.26-.32-.4-.47a32.57 32.57 0 0 0-4.03-3.67Z",
    style: {
      opacity: 0.2,
      transformOrigin: "266.205px 406.56px"
    },
    className: "animable",
    id: "eloe46gte3bci"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.72 399.75 53.44-32.84a10.27 10.27 0 0 0-2.13-1.7c-1.69-1-3.21-1-4.28-.29l-51.95 32.84a2.93 2.93 0 0 1 2.95.29 7.62 7.62 0 0 1 1.97 1.7Z",
    style: {
      opacity: 0.15,
      transformOrigin: "298.98px 382.085px"
    },
    className: "animable",
    id: "elr9aymrkw1m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.25 415.81v11.82c0 6.41 4.24 12.83 12.72 17.73 17 9.79 44.46 9.79 61.43 0 8.48-4.9 12.72-11.32 12.72-17.73v-11.82c0-6.42-4.24-12.84-12.72-17.74-17-9.79-44.47-9.79-61.43 0-8.48 4.9-12.72 11.32-12.72 17.74Zm82.67 0c0 5.13-3.77 10.14-10.62 14.09-7.58 4.37-17.74 6.78-28.62 6.78s-21-2.41-28.61-6.78c-6.85-3.95-10.62-9-10.62-14.09s3.77-10.14 10.62-14.1c7.58-4.37 17.74-6.78 28.61-6.78s21 2.41 28.62 6.78c6.85 3.96 10.62 8.96 10.62 14.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "225.685px 421.715px"
    },
    id: "elgfl3r9qmx3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.4 398.07c-17-9.79-44.46-9.79-61.43 0s-17 25.67 0 35.47 44.47 9.79 61.43 0 16.96-25.67 0-35.47Zm-2.1 31.83c-7.58 4.37-17.74 6.78-28.61 6.78s-21-2.41-28.62-6.78c-6.84-3.95-10.62-9-10.62-14.09s3.78-10.14 10.62-14.1c7.58-4.37 17.74-6.78 28.62-6.78s21 2.41 28.61 6.78c6.85 4 10.62 9 10.62 14.1S261.15 426 254.3 429.9Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "225.676px 415.807px"
    },
    className: "animable",
    id: "ela837uf0vsjm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.92 415.8a11.74 11.74 0 0 1-1.69 5.92c-1.73-3-4.76-5.78-8.93-8.18-7.57-4.38-17.74-6.79-28.62-6.79s-21 2.41-28.6 6.79c-4.18 2.4-7.21 5.2-8.94 8.18a11.74 11.74 0 0 1-1.69-5.92c0-5.13 3.77-10.14 10.63-14.09 7.57-4.37 17.73-6.78 28.6-6.78s21 2.41 28.62 6.78c6.85 3.95 10.62 8.96 10.62 14.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "225.685px 408.325px"
    },
    id: "elyb5zftw3hx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.92 415.8a11.74 11.74 0 0 1-1.69 5.92c-1.73-3-4.76-5.78-8.93-8.18-7.57-4.38-17.74-6.79-28.62-6.79s-21 2.41-28.6 6.79c-4.18 2.4-7.21 5.2-8.94 8.18a11.74 11.74 0 0 1-1.69-5.92c0-5.13 3.77-10.14 10.63-14.09 7.57-4.37 17.73-6.78 28.6-6.78s21 2.41 28.62 6.78c6.85 3.95 10.62 8.96 10.62 14.09Z",
    style: {
      opacity: 0.1,
      transformOrigin: "225.685px 408.325px"
    },
    className: "animable",
    id: "el6swfabz4yzu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.3 407.06c-7.58-4.37-17.74-6.78-28.61-6.78s-21 2.41-28.62 6.78c-5.65 3.27-9.2 7.25-10.27 11.42 1.07 4.18 4.62 8.16 10.27 11.42 7.58 4.37 17.74 6.78 28.62 6.78s21-2.41 28.61-6.78c5.65-3.26 9.2-7.24 10.27-11.42-1.07-4.17-4.57-8.15-10.27-11.42Z",
    style: {
      fill: "#fff",
      opacity: 0.6,
      transformOrigin: "225.685px 418.48px"
    },
    className: "animable",
    id: "elx9thx8mshw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.92 440.18V452a57.1 57.1 0 0 0 20.47-6.64c8.49-4.9 12.73-11.32 12.73-17.74V415.8a15.14 15.14 0 0 0-.52-3.87c2.06 7.64-2 15.72-12.2 21.61a57.1 57.1 0 0 1-20.48 6.64Z",
    style: {
      opacity: 0.1,
      transformOrigin: "252.52px 431.965px"
    },
    className: "animable",
    id: "el3soijmjafwu"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-138",
    className: "animable",
    style: {
      transformOrigin: "383.654px 256.593px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-138",
    className: "animable",
    style: {
      transformOrigin: "383.654px 256.593px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-138",
    className: "animable",
    style: {
      transformOrigin: "404.407px 319.408px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.34 399.13c0-.23.8-12.44.8-12.44s-3.16 1.91-10.48 1.86c-3.73 0-9-3-9-3l.77 12.09c-.84-.23-1 1.83-2.45 2.62-2.42 1.38-7 1.65-11.39 1.92-1.15.08-2.47 0-3.66.07h-.08c-3.63.76-6.67 4-2.16 6.15s11 1.74 16.88 1.28c7.09-.56 21.29-3.19 20.77-10.55Z",
    style: {
      fill: "#b16668",
      transformOrigin: "390.785px 397.799px"
    },
    id: "el6oef64als0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.06 408.9a7.78 7.78 0 0 0 .21 4c.38 1.37 4.57 5.45 11 7.18s13.66.47 17.23.81 7.06 1.75 11.24 2 9.82-.05 12.12-3.9a4.66 4.66 0 0 0 0-3.4c-.86-.68-51.8-6.69-51.8-6.69Z",
    style: {
      fill: "#263238",
      transformOrigin: "386.037px 415.928px"
    },
    id: "elxtm7kunqnhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.29 396c-.7-.33-1.57 2-2.52 2.33-2.78 1-7 .91-11.4 1.26-5.55.44-12-.32-15.47 1.75s-4 6.6 2.1 11.4c1.75 1.39 3.72 3.24 5.61 4 6.29 2.42 12.83 1 17 1.18 5.43.3 9.17 3 14.08 2.64 6.35-.49 9.62-2 10.27-5.77s-1.12-7.47-1.06-11.73c0-2.91.65-4.24-.55-4.12a7.2 7.2 0 0 1-3.7 2.24c-4.7 1.4-5.92-.49-10.48 4.75-1.41 1.61-2.43.88-2.69.61-.9-1-1.31-2.51-1.2-5.12 0-.83.1-3.79.1-3.79Z",
    style: {
      fill: "#37474f",
      transformOrigin: "386.22px 408.281px"
    },
    id: "elefo1cvsx2ib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.61 416.72s-2.4-14.67 5.54-17l1-.06s-.19-1-3.35-1.19c-6.07-.37-9.88.5-12.37 3.27a8.43 8.43 0 0 0-1.46 7c.87 2.85 4.03 6.06 10.64 7.98Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "368.447px 407.555px"
    },
    id: "eljehgmbx9219",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.59 407.91s.43-6.86 5-8.4a4.75 4.75 0 0 1 2.36-.14s-5.12 1.32-5.62 8.55c0 0-.11.51-1 .52-.27 0-.77.03-.74-.53Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "378.269px 403.861px"
    },
    id: "elvp98f1vfyz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.6 399.11s-.08-.15-1-.06a4.44 4.44 0 0 0-1.16.23 8.7 8.7 0 0 0-4.38 8.66s-.08.53.78.4 1-.58 1-.58-.45-6.01 4.76-8.65Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "382.297px 403.691px"
    },
    id: "elzdmmtb31lzm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 398.57s-.21-.14-.95 0c-.92.19-1.09.41-1.09.41s-4.32 3.21-3.39 8.36c0 0 .05.55.92.37s.76-.72.76-.72a8.66 8.66 0 0 1 3.75-8.42Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "386.219px 403.127px"
    },
    id: "elgin1otqk089",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.83 373.32c-.2 2.64-.52 5 .46 7.91 1.41 4.16 4.39 6.06 6.14 7.71a31 31 0 0 1 5.1 6.43c1.24 2.11 1.73 4.57 5.32 6.93 3.19 2.11 9 2.22 12.61-.15 2.06-1.37 3-1.88 2.87-5.63s-15.08-4.23-15.08-4.23Z",
    style: {
      fill: "#263238",
      transformOrigin: "429.979px 388.613px"
    },
    id: "elzl2b9b2vns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.92 385.32c.93.37 1.16 2.22 1.31 5.9.1 2.78 1.22 6.85-2.45 8.61-3 1.41-8.51 3.11-13.73-1.35-3.11-2.65-4.2-6.15-7.77-10.15-3.09-3.46-6.32-4.63-7.69-11.56-.89-4.45-.19-6.29 2.68-7.57 4-1.75 10.17 4 13.26 4.88 2.67.78 13.47 10.92 14.39 11.24Z",
    style: {
      fill: "#37474f",
      transformOrigin: "430.348px 385.114px"
    },
    id: "el7gnefvzues7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.53 374.08a3.33 3.33 0 0 1-.52-.19 10.24 10.24 0 0 0-8.56 5.85c-.53 1.22 1.1 2.16 2.06 1.22a10.84 10.84 0 0 1 8.56-5.82 4.77 4.77 0 0 0-1.54-1.06Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "426.708px 377.616px"
    },
    id: "eld0t9lcunxec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.09 376.18a10.19 10.19 0 0 0-7.95 5.8c-.53 1.21 1.1 2.16 2.06 1.21a10.51 10.51 0 0 1 7.14-5.55c-.43-.52-.85-1.02-1.25-1.46Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "429.688px 379.879px"
    },
    id: "ele6clywryq85",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.4 381.9s.31-8.24 11-9.39l.62.36a9.37 9.37 0 0 0-5.26-4.23c-3.56-1-6.37 0-8.23 2.46s.02 9.19 1.87 10.8Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "420.892px 375.078px"
    },
    id: "el139jm73xwv9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.84 362.87s-.64 21.89-.81 23.26-.67 2.83-6 3.25-9.34-2.71-10-4.27-2.33-22.65-2.33-22.65Z",
    style: {
      fill: "#b16668",
      transformOrigin: "436.27px 375.939px"
    },
    id: "elku2azdxyjh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.07 333c0-15.61-.92-21.4-.92-21.4s.68-20.71.55-42.63c-.17-30.42 1.8-36.48-3.21-53.11-8.21 7.11-41.61 9.69-59.86 5.24-.52 36.7.71 87 1.1 96.65.44 10.92.91 20.46 2.78 45.91 1.21 16.52 2.33 29.77 2.33 29.77 9.92 6.09 19.43-.23 19.43-.23s2.61-31 3.75-42.08c1.2-11.83-.38-28.88-.38-28.88s2.51-25.88 3.43-33c0 0 1.09 10.94 1.79 20.61s1.49 13.7 3.17 32.41c1.65 18.36 4.46 39.07 4.46 39.07 10.68 3.4 18.35 0 18.35 0s3.22-37.28 3.23-48.33Z",
    style: {
      fill: "#455a64",
      transformOrigin: "417.287px 305.969px"
    },
    id: "elii74evgamdp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.07 289.25 3.58-29.72a32.2 32.2 0 0 0 19.27-7.39s-2.59 7.53-15.2 11.6l-5.09 25.58-.85 19.58Z",
    style: {
      fill: "#37474f",
      transformOrigin: "429.495px 280.52px"
    },
    id: "elo84554b3q4",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-138",
    className: "animable",
    style: {
      transformOrigin: "383.654px 167.727px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b16668",
      transformOrigin: "421.175px 149.255px"
    },
    id: "elyea7elgd7j",
    className: "animable",
    d: "m409.62 142.7 2.11 15.46 21-1.07-2.27-16.74-20.84 2.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.26 113.79c-1.61 2.06-6.64 8.25-6.83 9.43l4.1 2.52Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "397.845px 119.765px"
    },
    id: "el7c0h00sixmk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.94 98.25c-6.49-.7-10.7 3.9-12.59 17.71-.07.54-.87 1.39-1.48 3.46-2.6 8.86-1.14 17.3.35 19.54 3.76 3 7.94 4.15 14 3.64 4.61-.39 16.38-1.8 22.35-8 7-7.33 10.56-18.37 5.58-24.1-7.02-8.1-24.64-11.87-28.21-12.25Z",
    style: {
      fill: "#b16668",
      transformOrigin: "420.458px 120.449px"
    },
    id: "el794d2tezpoi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.22 139c.84 1.24 6.78 4.29 10.51 4.53l-.35-2.9a38.68 38.68 0 0 1-10.16-1.63Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "404.475px 141.265px"
    },
    id: "elvm4kevejiyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.65 122.45a1.22 1.22 0 0 0 2.17.36 16.38 16.38 0 0 1 2.37-2.75 5.91 5.91 0 0 1 4-1.35c5.45.41 4.12 7.59 1.44 10.09-4.37 4.08-6.7.55-6.7.55s-3.14 6.94 1.44 11c0 0 7.9 3.42 14.11 1.49 4.65-5 7.76-8.16 10.88-12.47 7.4-10.2 7.41-20.29 2.66-23.17.27-3.62-1.69-9.06-9.12-12.2-7.08-3-11.82-2.7-17-2.42s-11.41 2.63-16.17-1.35a9.74 9.74 0 0 0 .79 8.87 3.22 3.22 0 0 0-2.78 5.8 2.54 2.54 0 0 0-1.16 3 3.09 3.09 0 0 0 2.67 2 12.9 12.9 0 0 0 3.22-.21c1.49 4.18 6.21 5.65 9 5.47-.08 0-.45.57-.5.65a7.71 7.71 0 0 0-.44.72 8.24 8.24 0 0 0-.67 1.56 8.7 8.7 0 0 0-.4 3.36 3.23 3.23 0 0 0 .19 1Z",
    style: {
      fill: "#263238",
      transformOrigin: "422.679px 116.33px"
    },
    id: "elbuta6v9uxfe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.67 149c7.8-.37 15.54 1.94 20.28 12.8 4.48 10.27 10.78 25.1 13.1 32.56 1.13 3.64 3.19 6.91-3.59 13.32a107.52 107.52 0 0 1-20.82 14.83l-6.82-14.61 10.66-10.23-4.7-9.77Z",
    style: {
      fill: "#455a64",
      transformOrigin: "452.96px 185.737px"
    },
    id: "elidx86zkcrv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.48 197.63a13.94 13.94 0 0 0 6.32 5.37c-3 .73-6.29-2.5-7.29-4.4Z",
    style: {
      fill: "#263238",
      transformOrigin: "451.155px 200.368px"
    },
    id: "elmsk0x693y1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.29 151.28c5.45 3.05 9.58 13.23 9.18 21.72-.25 5.38-2.14 19.26-3.75 31.54-.51 3.86 1 10.39 1.74 18.23.53 5.82.61 12 .61 12s-7.3 9-27.35 10.22c-25.58 1.5-36.91-4.68-36.91-4.68s-.15-20.85.46-37.35c.92-24.48 1-31.64 4.8-40 1.26-2.47 2.59-7.95 6.75-9 3.3-.86 10.92-2.69 13.94-3.15 4.94 1.28 17.77 1.38 20.94-1.32l-.05-.71c5.5-.06 6.28.62 9.64 2.5Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "417.645px 197.001px"
    },
    id: "elczaqcyx393w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "417.645px 197.001px"
    },
    className: "animable",
    id: "elta2a6v5gdhk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.29 151.28c5.45 3.05 9.58 13.23 9.18 21.72-.25 5.38-2.14 19.26-3.75 31.54-.51 3.86 1 10.39 1.74 18.23.53 5.82.61 12 .61 12s-7.3 9-27.35 10.22c-25.58 1.5-36.91-4.68-36.91-4.68s-.15-20.85.46-37.35c.92-24.48 1-31.64 4.8-40 1.26-2.47 2.59-7.95 6.75-9 3.3-.86 10.92-2.69 13.94-3.15 4.94 1.28 17.77 1.38 20.94-1.32l-.05-.71c5.5-.06 6.28.62 9.64 2.5Z",
    style: {
      fill: "#fff",
      transformOrigin: "417.645px 197.001px"
    },
    id: "ellvfp1ayyf8m",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-138",
    className: "animable",
    style: {
      transformOrigin: "349.324px 152.651px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315 133.77c-2.82-3.52-4.31-5-5.82-5.88s-6.61-4.77-8.66-5.9c-1.3-.71-2.44 1.36-1.07 3.34 1.06 1.53 4.2 4 5.53 5.26s3.41 5.77 3.41 5.77Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "306.914px 129.104px"
    },
    id: "elzkg70h0ruue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.9 180.71c3 1.67 5.87 1.23 15.9.7 7.16-.38 17.06-.67 33.9-2.24 6.29-6.3 7.81-17.31 1.54-24.06-6.55-1.51-26.38 6.45-47.56 6 0 0-20.88-9.55-23.18-11.25s-6.52-10.63-8.11-13.23c-2.17-3.54-3.7-3.55-5.23-3.71-5-.54-6.18-.42-7.37 0a2.28 2.28 0 0 0-1.43 1.64c-1.33-.18-3.23-.72-4 1.32a6 6 0 0 0-.52 1.66 1.47 1.47 0 0 0-1 .26c-1.39.95-.68 5.71.21 7 .62 1 1.76 1.35 3.34 1.54 1.34.16 1.08-1.31 1.08-1.31l1.79.58c3.19 3.81 1.94 9.39 6.8 12a35.67 35.67 0 0 1 6 2.89c11.94 9.5 24.03 18.06 27.84 20.21Z",
    style: {
      fill: "#b16668",
      transformOrigin: "348.653px 157.223px"
    },
    id: "el42tpbazcs4w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.36 134.5 6 .34-5.71-1.11a2.34 2.34 0 0 0-.29.77Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "306.36px 134.285px"
    },
    id: "elejxncsj2o2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.81 137.48 6.82.88-6.63-1.65a3.47 3.47 0 0 0-.19.77Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "302.22px 137.535px"
    },
    id: "elmq2wl0bk3fk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.92 140.61a2.09 2.09 0 0 0 .68 1 4.76 4.76 0 0 0 1 .69l-.07-.09c.08.39.18.78.28 1.16l.19-.14a1.37 1.37 0 0 0-1.12 0 1.73 1.73 0 0 0-.8.71 2.22 2.22 0 0 1 .86-.55 1.37 1.37 0 0 1 .94.08l.24.11-.06-.26c-.09-.39-.18-.78-.29-1.16v-.06h-.06a6 6 0 0 1-1-.59 2.45 2.45 0 0 1-.79-.9Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "300.02px 142.275px"
    },
    id: "elfsd8qpsf2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45 141.92a20.41 20.41 0 0 0 2.34.79 2.64 2.64 0 0 0 .48 1.49 14.37 14.37 0 0 0 1 1.4l-1.79-.58s-.23-.93-1.78-1.67Z",
    style: {
      fill: "#9a4a4d",
      transformOrigin: "302.36px 143.76px"
    },
    id: "elk7ddajxtvbj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.44 153.81a52.8 52.8 0 0 0-12.85 1.81c-3.9 1.06-18.16 3.75-22.25 4.14s-13.68.88-13.68.88L336 155.19s-2.24.76-4.5 5.45-.77 10.88-.77 10.88 11.16 7.7 13.58 9.27 3.82 1.93 7.54 1.65 28.65-1.81 31.49-1.49 3.62 1.33 5.21 2.25 5.84-.66 8.56-4.78 8.38-18.58.33-24.61Z",
    style: {
      fill: "#455a64",
      transformOrigin: "365.92px 168.632px"
    },
    id: "elho6xn4snsy",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-138",
    className: "animable",
    style: {
      transformOrigin: "420.25px 55.8758px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "420.25px 55.8758px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "420.25px 55.8758px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m418.65 85 3.11-5.85-2.5-7.24V67.5l7.67 4.43v4.43l-3.3 5.71a.52.52 0 0 1-.22.2Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "422.79px 76.25px"
    },
    id: "el5vq0upltb5w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.65 85 3.11-5.85-2.5-7.24V67.5l7.67 4.43v4.43l-3.3 5.71a.52.52 0 0 1-.22.2Z",
    style: {
      opacity: 0.2,
      transformOrigin: "422.79px 76.25px"
    },
    className: "animable",
    id: "eln4blezm3xj9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.33 32.28a5.08 5.08 0 0 1 2.3-4l1.87-1.08a5.1 5.1 0 0 1 4.6 0l28.72 16.61a5.1 5.1 0 0 1 2.3 4v31.6a5.07 5.07 0 0 1-2.3 4L436 84.49a5.1 5.1 0 0 1-4.6 0l-9.24-5.34-3.29 5.7a.49.49 0 0 1-.89-.08l-3.48-10-11.82-6.85a5.07 5.07 0 0 1-2.3-4Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "420.225px 55.8758px"
    },
    id: "elw8mi786ch0i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.12 79.42a5.07 5.07 0 0 1-2.3 4L436 84.49a5.14 5.14 0 0 1-4.21.18c1.09.41 1.91-.2 1.91-1.51V51.55a4.75 4.75 0 0 0-.67-2.26l6.47-3.74a4.64 4.64 0 0 1 .67 2.27Z",
    style: {
      opacity: 0.2,
      transformOrigin: "435.98px 65.293px"
    },
    className: "animable",
    id: "elowksqo1pqlp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.4 31.63c.27-1 1.16-1.29 2.22-.67l28.73 16.61a4.64 4.64 0 0 1 1.65 1.72l6.47-3.74a4.61 4.61 0 0 0-1.62-1.71L409.1 27.22a5.1 5.1 0 0 0-4.6 0l-1.88 1.08a5.13 5.13 0 0 0-2.22 3.33Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "419.935px 37.981px"
    },
    className: "animable",
    id: "el661jv6rrcfj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Check--inject-138",
    className: "animable",
    style: {
      transformOrigin: "417.686px 58.8994px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413 68.87a1.67 1.67 0 0 1-.31 0 2.33 2.33 0 0 1-1.81-1.32l-3.76-7.94a2.34 2.34 0 0 1 4.24-2l2.23 4.67 10.76-12.54a2.34 2.34 0 0 1 3.56 3.05l-13.1 15.27a2.35 2.35 0 0 1-1.81.81Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "417.686px 58.8994px"
    },
    id: "eln2kzqhwlld",
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingSelected);
export default __webpack_public_path__ + "static/media/nothingSelected.2df4209a7344cf85fd58e3bfa6595ccd.svg";
export { ForwardRef as ReactComponent };